/* Business Phones Direct — storefront behaviour.
   Everything here degrades gracefully: prices, plans and links all render
   correct without JS; this only swaps values and opens the mobile drawer. */
(function () {
  'use strict';

  var money = function (n) {
    if (!isFinite(n)) return '';
    var v = Math.round(n * 100) / 100;
    var str = v % 1 === 0 ? String(v) : v.toFixed(2);
    // thousands separators, without relying on Intl being present
    var parts = str.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '£' + parts.join('.');
  };



  /* Marketing events. Fires whatever is present — Meta pixel, GA4, Shopify
     analytics — and stays silent when none of them are. Never throws, because
     an ad-blocker eating the pixel must not take the buy button with it. */
  function track(event, data, eventId) {
    data = data || {};
    /* eventID pairs this browser event with the copy the Worker sends from
       the server. Meta collapses the two into ONE conversion — without it the
       same order counts twice and every number downstream is fiction. */
    try {
      if (typeof window.fbq === 'function') {
        if (eventId) window.fbq('track', event, data, { eventID: eventId });
        else window.fbq('track', event, data);
      }
    } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', event, data); } catch (e) {}
    try {
      document.dispatchEvent(new CustomEvent('bpd:track', { detail: { event: event, data: data } }));
    } catch (e) {}
  }

  /* The event worth optimising towards.

     We buy "Lead" today, which tells Meta to find the cheapest person who will
     complete a form - and the cheapest person who will fill in twenty fields
     for 150 pounds cash is, by construction, somebody who needs 150 pounds.
     That is why nine in ten of them fail the credit check.

     This fires only once a real limited company has been matched on the
     Companies House register, which is the precondition for passing credit.
     Deliberately NOT the credit approval itself: approvals run at two a week
     and would still be under Meta's learning threshold at 100k a month, so an
     ad set optimised on them would never leave learning. This one carries the
     volume and still points at the right person.

     Once per company per visit - the picker can be reopened. */
  var qualifiedSent = {};
  function qualified(number, name) {
    try {
      if (!number || qualifiedSent[number]) return;
      qualifiedSent[number] = true;
      /* One id, both paths: the browser event and the server's copy share it
         so Meta collapses them into one conversion instead of counting two. */
      var eid = 'ql-' + String(number) + '-' + Date.now().toString(36);
      track('QualifiedLead', {
        content_name: 'limited_company_verified',
        content_category: 'buy_flow',
        company_number: String(number),
        company_name: String(name || ''),
      }, eid);

      /* And server side, because the theme's pixel block only renders when a
         Meta pixel ID is set and it is not - so the browser event above
         currently reaches nobody. This one does not depend on it. */
      var base = (document.documentElement.getAttribute('data-bpd-application-endpoint') || '').trim();
      if (base) {
        var fb = fbIdentity();
        fetch(base.replace(/\/$/, '') + '/meta/qualified', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          keepalive: true,
          body: JSON.stringify({
            companyNumber: String(number), eventId: eid,
            pageUrl: location.href, fbp: fb.fbp, fbc: fb.fbc,
          }),
        }).catch(function () {});
      }
    } catch (e) {}
  }

  function readCookie(name) {
    try {
      var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
      return m ? decodeURIComponent(m[2]) : '';
    } catch (e) { return ''; }
  }

  /* Meta's click identifiers, forwarded to the server so it can attribute a
     conversion to the ad that caused it.

     `_fbp` is written by the pixel. `_fbc` only exists once someone has
     arrived on an ad click — and when the pixel is blocked the cookie never
     appears at all, so it is rebuilt from the `fbclid` in the URL. That click
     is the single most valuable thing to attribute; losing it to an ad
     blocker loses the point of the campaign. */
  function fbIdentity() {
    var fbc = readCookie('_fbc');
    if (!fbc) {
      var clid = '';
      try { clid = new URLSearchParams(location.search).get('fbclid') || ''; } catch (e) {}
      if (clid) fbc = 'fb.1.' + Date.now() + '.' + clid;
    }
    return { fbc: fbc, fbp: readCookie('_fbp') };
  }

  /* Ad attribution. Which ad produced an ORDER is only knowable from the
     utm_content on the click that brought them, and that query string is gone
     the moment they navigate. So it is captured on sight and persisted —
     otherwise every order that takes more than one page view is
     unattributable, and that data cannot be reconstructed later.

     Overwritten by a newer ad click rather than kept as first-touch, so it
     agrees with Meta, which attributes on last click. */
  var UTM_KEY = 'bpd_utm_v1';
  var UTM_FIELDS = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'];
  function captureUtms() {
    var got = {};
    try {
      var q = new URLSearchParams(location.search);
      for (var i = 0; i < UTM_FIELDS.length; i++) {
        var v = q.get(UTM_FIELDS[i]);
        if (v) got[UTM_FIELDS[i]] = String(v).slice(0, 120);
      }
      if (got.utm_content || got.utm_campaign || got.utm_source) {
        localStorage.setItem(UTM_KEY, JSON.stringify(got));
        return got;
      }
      return JSON.parse(localStorage.getItem(UTM_KEY) || '{}') || {};
    } catch (e) { return got; }
  }
  captureUtms();   // persist on first sight, before any navigation loses it

  /* One id per conversion, generated once and reused by both the pixel and
     the server send. */
  function newEventId() {
    try { if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID(); } catch (e) {}
    return 'e' + Date.now() + '-' + Math.random().toString(16).slice(2, 10);
  }

  /* Shared celebration burst. DOM nodes rather than a canvas so it can fire
     over any element, and it self-cleans. Skipped under reduced motion. */
  function confetti(anchor, count) {
    if (!anchor) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var n = count || 34;
    var colours = ['#E60000', '#FF3B3B', '#FF9A9A', '#1C1B1B', '#FFFFFF', '#FFC7C7'];
    var wrap = document.createElement('div');
    wrap.className = 'bpd-confetti';
    anchor.appendChild(wrap);

    for (var i = 0; i < n; i++) {
      var bit = document.createElement('i');
      var size = 6 + Math.random() * 7;
      bit.style.cssText =
        'left:' + (10 + Math.random() * 80) + '%;' +
        'width:' + size + 'px;height:' + (size * (Math.random() < .4 ? 1 : 1.8)) + 'px;' +
        'background:' + colours[i % colours.length] + ';' +
        'border-radius:' + (Math.random() < .3 ? '50%' : '2px') + ';';
      wrap.appendChild(bit);
      bit.animate([
        { transform: 'translate3d(0,0,0) rotate(0deg)', opacity: 1 },
        { transform: 'translate3d(' + (Math.random() * 220 - 110) + 'px,' +
            (160 + Math.random() * 200) + 'px,0) rotate(' + (Math.random() * 720 - 360) + 'deg)', opacity: 0 },
      ], {
        duration: 1100 + Math.random() * 900,
        easing: 'cubic-bezier(.2,.7,.3,1)',
        delay: Math.random() * 160,
        fill: 'forwards',
      });
    }
    window.setTimeout(function () { if (wrap.parentNode) wrap.parentNode.removeChild(wrap); }, 2400);
  }

  /* ---------- Plans: contract-length + VAT toggles ---------- */
  function initPlans(root) {
    var vatRate = parseFloat(root.dataset.vatRate || '20') / 100;
    var termBtns = root.querySelectorAll('[data-bpd-term]');
    var vatBtn = root.querySelector('[data-bpd-vat]');
    var vatLabel = root.querySelector('[data-bpd-vat-label]');
    var plans = root.querySelectorAll('[data-bpd-plan]');

    var section = root.closest('section') || document;
    var labels = {
      ex: (vatLabel && vatLabel.dataset.ex) || (vatLabel ? vatLabel.textContent.trim() : ''),
      inc: (vatLabel && vatLabel.dataset.inc) || ''
    };

    var state = { term: '24', inc: false };
    for (var i = 0; i < termBtns.length; i++) {
      if (termBtns[i].getAttribute('aria-selected') === 'true') state.term = termBtns[i].dataset.bpdTerm;
    }

    function render() {
      for (var i = 0; i < plans.length; i++) {
        var p = plans[i];
        // NB: read via getAttribute — dataset camel-casing does NOT fold a
        // digit onto the previous word, so data-price-24 is dataset['price-24'].
        var base = parseFloat(p.getAttribute('data-price-' + state.term));
        var was = parseFloat(p.getAttribute('data-was-' + state.term));
        var mult = state.inc ? 1 + vatRate : 1;

        var amountEl = p.querySelector('[data-bpd-amount]');
        if (amountEl && isFinite(base)) amountEl.textContent = money(base * mult);

        var wasEl = p.querySelector('[data-bpd-was]');
        if (wasEl) {
          if (isFinite(was) && was > base) {
            wasEl.textContent = money(was * mult);
            wasEl.hidden = false;
          } else {
            wasEl.textContent = '';
            wasEl.hidden = true;
          }
        }

        var note = p.querySelector('[data-bpd-vatnote]');
        if (note) {
          if (!note.dataset.ex) note.dataset.ex = note.textContent.trim();
          note.textContent = state.inc ? (note.dataset.inc || 'including VAT') : note.dataset.ex;
        }
      }

      for (var j = 0; j < termBtns.length; j++) {
        termBtns[j].setAttribute('aria-selected', termBtns[j].dataset.bpdTerm === state.term ? 'true' : 'false');
      }
      if (vatBtn) vatBtn.setAttribute('aria-checked', state.inc ? 'true' : 'false');
      if (vatLabel && labels.inc) vatLabel.textContent = state.inc ? labels.inc : labels.ex;
    }

    for (var k = 0; k < termBtns.length; k++) {
      termBtns[k].addEventListener('click', function () {
        state.term = this.dataset.bpdTerm;
        render();
      });
    }
    if (vatBtn) {
      vatBtn.addEventListener('click', function () { state.inc = !state.inc; render(); });
    }

    render();   // write real values immediately — never leave them to an animation
  }







  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.bpd-rise');
    if (!els.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Bail out of the reveal entirely — and un-hide everything — whenever the
       animation can't be trusted to finish:
         · reduced motion
         · no IntersectionObserver
         · the document is hidden (background tab, prerender, embedded webview)
       A hidden document FREEZES CSS transitions, so an element can carry
       .is-in and still compute to opacity 0 forever. Anyone loading the page
       in a background tab would switch to it and find blank sections.
       DESIGN.md §6: motion never gates information. */
    if (reduce || !('IntersectionObserver' in window) || document.hidden) {
      document.documentElement.classList.remove('bpd-js');
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          entries[i].target.classList.add('is-in');
          io.unobserve(entries[i].target);
        }
      }
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    for (var i = 0; i < els.length; i++) {
      // Anything already on screen at load reveals immediately — a first
      // paint should never look like it's waiting for something.
      var r = els[i].getBoundingClientRect();
      if (r.top < window.innerHeight * 0.92) els[i].classList.add('is-in');
      else io.observe(els[i]);
    }

    // If the page is ever hidden mid-session, stop choreographing and show
    // everything — transitions won't resume reliably from a frozen state.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) document.documentElement.classList.remove('bpd-js');
    }, { once: true });

    // Backstop for anything unforeseen: reveal whatever is still hidden.
    // Content beats choreography.
    window.setTimeout(function () {
      var stuck = document.querySelectorAll('.bpd-rise:not(.is-in)');
      for (var i = 0; i < stuck.length; i++) stuck[i].classList.add('is-in');
      io.disconnect();
    }, 4000);
  }

  /* ---------- Count-up stats ---------- */
  function initCountUps() {
    var els = document.querySelectorAll('[data-countup]');
    if (!els.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    for (var i = 0; i < els.length; i++) {
      (function (el) {
        var full = el.textContent.trim();
        var m = /^(\D*)(\d[\d,.]*)(.*)$/.exec(full);
        // The real value is written synchronously and never depends on a frame
        // firing — background tabs and hidden webviews must still read right.
        el.textContent = full;
        if (!m || reduce) return;

        var target = parseFloat(m[2].replace(/,/g, ''));
        // Counting 5 up to 5 is not a flourish, it's a flicker
        if (!isFinite(target) || target < 10) return;

        var pre = m[1], post = m[3];
        var ran = false;

        function run() {
          if (ran) return;
          ran = true;

          // A hidden document fires zero animation frames, so animating here
          // would strand a half-counted number on screen forever.
          if (document.hidden) { el.textContent = full; return; }

          var start = null, dur = 900;
          // Safety net: whatever happens to rAF — throttled tab, backgrounded
          // webview, device asleep — the true value lands. rAF is the flourish,
          // never the thing responsible for correctness.
          var settle = window.setTimeout(function () { el.textContent = full; }, dur + 250);

          function step(ts) {
            if (start === null) start = ts;
            var p = Math.min(1, (ts - start) / dur);
            var eased = 1 - Math.pow(1 - p, 3);
            el.textContent = pre + String(Math.round(target * eased)) + post;
            if (p < 1) { requestAnimationFrame(step); return; }
            window.clearTimeout(settle);
            el.textContent = full;
          }
          requestAnimationFrame(step);
        }

        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting) { run(); io.disconnect(); }
          }, { threshold: 0.4 });
          io.observe(el);
        }
      })(els[i]);
    }
  }








  /* ---------- Lead capture ----------
     One place that knows how to take a mobile number, record consent, and
     hand the lead on with whatever qualification the page already knows.
     Progressive: once we have a number we don't ask for it again. */
  var LEAD_KEY = 'bpd_lead_v1';

  function knownLead() {
    try { return JSON.parse(localStorage.getItem(LEAD_KEY) || '{}'); }
    catch (e) { return {}; }
  }

  function rememberLead(data) {
    var next = knownLead();
    for (var k in data) if (Object.prototype.hasOwnProperty.call(data, k)) next[k] = data[k];
    try { localStorage.setItem(LEAD_KEY, JSON.stringify(next)); } catch (e) {}
    return next;
  }

  /* UK mobile numbers, tolerant of spacing and +44. Deliberately permissive:
     rejecting a real customer's number costs far more than a bad row. */
  function normaliseMobile(v) {
    var d = String(v || '').replace(/[^\d+]/g, '');
    if (/^\+44/.test(d)) d = '0' + d.slice(3);
    if (/^44\d{10}$/.test(d)) d = '0' + d.slice(2);
    return d;
  }
  /* iOS Safari ignores `overflow: hidden` on <html> for touch scrolling, so
     every modal here let the page scroll away underneath it and come back at
     a different position. Pinning <body> with position:fixed is the only
     thing that actually holds on iOS — but it collapses the scroll offset, so
     the offset has to be stored and restored by hand or closing the modal
     dumps you at the top of the page.

     Counted, because these can stack: the scratch takeover can sit over the
     page and open the buy sheet on top of it, and a naive unlock on the first
     close would free the background while a modal is still up. */
  var scrollLocks = 0;
  var lockedScrollY = 0;

  function lockScroll() {
    if (scrollLocks++) return;
    lockedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var b = document.body;
    b.style.position = 'fixed';
    b.style.top = -lockedScrollY + 'px';
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
    document.documentElement.style.overflow = 'hidden';
  }

  function unlockScroll() {
    if (!scrollLocks || --scrollLocks) return;
    var b = document.body;
    b.style.position = '';
    b.style.top = '';
    b.style.left = '';
    b.style.right = '';
    b.style.width = '';
    document.documentElement.style.overflow = '';
    window.scrollTo(0, lockedScrollY);
  }

  /* 07 + 9 digits, and nothing else. The old fallback here also allowed
     /^0\d{9,10}$/, which waved through any landline — 01/02/03 numbers passed
     while the error message told people it had to start 07. This is a mobile
     contract and the number gets ported, so a landline is always wrong data. */
  function looksLikeUkMobile(v) {
    return /^07\d{9}$/.test(normaliseMobile(v));
  }

  /* Wire a capture form. `context()` returns whatever qualification the host
     section knows — line count, cashback value, prize code — so sales get the
     deal size with the number instead of ringing blind. */
  function initLeadForm(form, opts) {
    if (!form) return;
    opts = opts || {};
    var input = form.querySelector('[data-bpd-lead-mobile]');
    var consent = form.querySelector('[data-bpd-lead-consent]');
    if (!input) return;

    // Progressive profiling — don't make them type it twice
    var known = knownLead();
    if (known.mobile) input.value = known.mobile;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!looksLikeUkMobile(input.value)) {
        input.setCustomValidity('Please enter a UK mobile number');
        input.reportValidity();
        input.addEventListener('input', function once() {
          input.setCustomValidity('');
          input.removeEventListener('input', once);
        });
        return;
      }

      var ctx = typeof opts.context === 'function' ? opts.context() : {};
      var lead = rememberLead({
        mobile: normaliseMobile(input.value),
        // Consent to be CALLED is separate from claiming the offer. PECR
        // requires it to be specific, so it is recorded as given or not —
        // never assumed from the submit.
        callConsent: !!(consent && consent.checked),
        consentAt: new Date().toISOString(),
        source: opts.source || 'unknown',
      });
      for (var k in ctx) if (Object.prototype.hasOwnProperty.call(ctx, k)) lead[k] = ctx[k];
      rememberLead(ctx);

      track('Lead', {
        content_name: opts.source || 'lead',
        content_category: lead.callConsent ? 'call-consented' : 'no-call-consent',
        value: Number(ctx.cashback) || 0,
        currency: 'GBP',
        num_items: Number(ctx.lines) || 1,
      });

      document.dispatchEvent(new CustomEvent('bpd:lead', { detail: lead }));
      sendLead(lead);
      if (typeof opts.onDone === 'function') opts.onDone(lead);
    });
  }

  /* ---------- Lead delivery ----------
     A captured mobile number that only lives in localStorage is a lost lead.
     The endpoint is a theme setting so it can be pointed at Klaviyo, Zapier,
     a CRM or an app proxy without touching this file.

     Delivery is fire-and-forget on purpose: the visitor has already been told
     the claim worked, so a slow or failing endpoint must never block the UI or
     surface an error to them. Failures queue and retry on the next capture. */
  var LEAD_ENDPOINT = (document.documentElement.getAttribute('data-bpd-lead-endpoint') || '').trim();
  var LEAD_QUEUE_KEY = 'bpd_lead_queue_v1';

  function readQueue() {
    try { return JSON.parse(localStorage.getItem(LEAD_QUEUE_KEY) || '[]'); } catch (e) { return []; }
  }
  function writeQueue(q) {
    try { localStorage.setItem(LEAD_QUEUE_KEY, JSON.stringify(q.slice(-20))); } catch (e) {}
  }

  function postLead(lead) {
    var body = JSON.stringify(lead);
    // sendBeacon survives the page being closed mid-submit, which is the
    // common case on mobile — but it can't report failure, so we only trust
    // it when the tab is going away.
    if (document.visibilityState === 'hidden' && navigator.sendBeacon) {
      try { return Promise.resolve(navigator.sendBeacon(LEAD_ENDPOINT, body)); } catch (e) {}
    }
    return fetch(LEAD_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body,
      keepalive: true,
      mode: 'cors',
      credentials: 'omit',
    }).then(function (r) { return r && r.ok; }).catch(function () { return false; });
  }

  function flushLeads() {
    if (!LEAD_ENDPOINT) return;
    var q = readQueue();
    if (!q.length) return;
    writeQueue([]);
    q.forEach(function (lead) {
      Promise.resolve(postLead(lead)).then(function (ok) {
        if (!ok) writeQueue(readQueue().concat([lead]));
      });
    });
  }

  /* ---- one lead pipeline -------------------------------------------------
     Every touchpoint that captures a phone number or an email lands in the
     same place: a source-labelled draft order in Shopify, which is the sales
     call queue. Before this, three of the four sources went nowhere at all —
     `bpd_lead_endpoint` was never given a value, so sendLead() returned on
     its first line and the scratch card, exit popup and cashback builder
     silently binned every lead they collected.

     One draft per visitor, not one per touchpoint: the same person hitting
     the cashback gate and then the order flow is ONE person to ring, and
     duplicate rows in a call queue get someone rung twice. The draft records
     where they were first seen and where they were last seen. */
  var PARTIAL_KEY = 'bpd_partial_v1';
  var FIRST_SOURCE_KEY = 'bpd_first_source_v1';

  function readPartialId() {
    try { return localStorage.getItem(PARTIAL_KEY) || null; } catch (e) { return null; }
  }
  function writePartialId(id) {
    try { if (id) localStorage.setItem(PARTIAL_KEY, id); else localStorage.removeItem(PARTIAL_KEY); } catch (e) {}
  }
  function firstSource(current) {
    try {
      var v = localStorage.getItem(FIRST_SOURCE_KEY);
      if (!v && current) { localStorage.setItem(FIRST_SOURCE_KEY, current); return current; }
      return v || current;
    } catch (e) { return current; }
  }

  /* `beacon` is for the unload path: fetch is cancelled when the tab goes
     away, sendBeacon is not. It cannot read a response, so anything that
     needs the returned id must use the normal path. */
  function postPartial(body, beacon) {
    var url = (document.documentElement.getAttribute('data-bpd-application-endpoint') || '').trim();
    if (!url) return;
    body.partial = true;
    body.partialId = readPartialId();
    body.firstSource = firstSource(body.source);
    body.utm = captureUtms();
    var payload = JSON.stringify(body);

    if (beacon && navigator.sendBeacon) {
      try { navigator.sendBeacon(url, new Blob([payload], { type: 'application/json' })); } catch (e) {}
      return;
    }
    fetch(url, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: payload, mode: 'cors', credentials: 'omit', keepalive: true
    })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function (d) { if (d) writePartialId(d.partialId || null); })
      .catch(function () {});
  }

  function sendLead(lead) {
    /* A dedicated lead endpoint wins if one is ever configured (a CRM, say).
       Otherwise the lead becomes a draft order, so nothing is lost either
       way. */
    if (LEAD_ENDPOINT) {
      flushLeads();
      Promise.resolve(postLead(lead)).then(function (ok) {
        if (!ok) writeQueue(readQueue().concat([lead]));
      });
      return;
    }
    /* Send a line count ONLY where one was genuinely captured. The scratch
       card and the exit popup ask for a phone number and nothing else, so
       `|| 1` here was inventing a one-line deal and a £150 cashback figure
       and handing them to sales as fact. Omitted means unknown, and the
       draft says so in as many words. */
    var body = {
      source: lead.source,
      name: lead.name || '',
      email: lead.email || '',
      mobile: lead.mobile || '',
      /* Consent to be CALLED is separate from claiming an offer, and this is
         a call list — whoever rings has to see it. PECR needs specific
         consent; without it the number must be screened against TPS/CTPS
         before anyone dials. */
      callConsent: !!lead.callConsent,
      prize: lead.prize || ''
    };
    if (Number(lead.lines) > 0) { body.lines = Number(lead.lines); body.quantity = Number(lead.lines); }
    if (Number(lead.cashback) > 0) body.cashback = Number(lead.cashback);
    /* The per-line rate is the standing offer and holds on every deal, so it
       goes even when the line count does not. */
    if (Number(lead.cashbackPerLine) > 0) body.cashbackPerLine = Number(lead.cashbackPerLine);
    postPartial(body, false);
  }

  /* Formats as you type without fighting the caret: count the digits before
     the cursor, reformat, then put the cursor back after that many digits. A
     naive re-set sends the caret to the end and makes editing miserable. */
  function maskDigits(el, max, groupEvery, sep) {
    var caret = el.selectionStart;
    var before = el.value.slice(0, caret).replace(/\D/g, '').length;
    var digits = el.value.replace(/\D/g, '').slice(0, max);
    var out = groupEvery
      ? digits.replace(new RegExp('(\\d{' + groupEvery + '})(?=\\d)', 'g'), '$1' + sep)
      : digits;
    if (out === el.value) return;
    el.value = out;
    var pos = 0, seen = 0;
    while (pos < out.length && seen < before) {
      if (/\d/.test(out.charAt(pos))) seen++;
      pos++;
    }
    if (out.charAt(pos) === sep) pos++;
    try { el.setSelectionRange(pos, pos); } catch (e) {}
  }

  /* ---------- Buy flow: a few questions, then checkout ----------
     Replaces the product page in the funnel. The mobile number at step 3 is
     a real gate — nothing past it is reachable without a valid UK mobile,
     which is the whole point of asking there rather than at the end. */
  function initBuy(root) {
    var form = root.querySelector('.bpd-buy__form');
    if (!form) return;

    var dataEl = root.querySelector('[data-bpd-buy-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
    if (!variants.length) return;

    var LAST = 7;
    var perLine  = parseFloat(root.dataset.cashbackPerLine) || 150;
    var maxLines = parseInt(root.dataset.maxLines, 10) || 10;

    var idInput   = root.querySelector('[data-bpd-buy-variant]');
    var qtyInput  = root.querySelector('[data-bpd-buy-qty]');
    var propMob   = root.querySelector('[data-bpd-buy-propmobile]');
    var propPac   = root.querySelector('[data-bpd-buy-proppac]');
    var range     = root.querySelector('[data-bpd-buy-range]');
    var sims      = root.querySelectorAll('[data-bpd-buy-sim]');
    var companyEl = root.querySelector('[data-bpd-buy-company]');
    var nameEl    = root.querySelector('[data-bpd-buy-name]');
    var emailEl   = root.querySelector('[data-bpd-buy-email]');
    var mobile    = root.querySelector('[data-bpd-buy-mobile]');
    var gateErr   = root.querySelector('[data-bpd-buy-gateerr]');
    var otpPanel  = root.querySelector('[data-bpd-buy-verify]');
    var otpInput  = root.querySelector('[data-bpd-buy-otpinput]');
    var otpResend = root.querySelector('[data-bpd-buy-otpresend]');
    var otpBack   = root.querySelector('[data-bpd-buy-otpback]');
    var wcoPanel  = root.querySelector('[data-bpd-buy-whichco]');
    var wcoList   = root.querySelector('[data-bpd-buy-whichco-list]');
    var wcoIntro  = root.querySelector('[data-bpd-buy-whichco-intro]');
    var wcoSkip   = root.querySelector('[data-bpd-buy-whichco-skip]');
    var otpStat   = root.querySelector('[data-bpd-buy-otpstatus]');
    var otpToEl   = root.querySelector('[data-bpd-buy-otpto]');
    var dob       = root.querySelector('[data-bpd-buy-dob]');
    var addrEl    = root.querySelector('[data-bpd-buy-addr]');
    var postEl    = root.querySelector('[data-bpd-buy-postcode]');
    var movedIn   = root.querySelector('[data-bpd-buy-movedin]');
    var prevWrap  = root.querySelector('[data-bpd-buy-prevwrap]');
    var prevRows  = root.querySelector('[data-bpd-buy-prevrows]');
    var prevTmpl  = root.querySelector('[data-bpd-buy-prevtemplate]');
    var prevHint  = root.querySelector('[data-bpd-buy-prevhint]');
    var titleEl   = root.querySelector('[data-bpd-buy-title]');
    var step4Err  = root.querySelector('[data-bpd-buy-step4err]');
    var sortEl    = root.querySelector('[data-bpd-buy-sort]');
    var acctEl    = root.querySelector('[data-bpd-buy-acct]');
    var acctNmEl  = root.querySelector('[data-bpd-buy-acctname]');
    var acctStEl  = root.querySelector('[data-bpd-buy-acctstatus]');
    var cPickEl   = root.querySelector('[data-bpd-buy-companypick]');
    var cStatEl   = root.querySelector('[data-bpd-buy-companystatus]');
    var soleEl    = root.querySelector('[data-bpd-buy-soletoggle]');
    var regEl     = root.querySelector('[data-bpd-buy-regoffice]');
    var regWrap   = root.querySelector('[data-bpd-buy-regofficewrap]');
    var regHint   = root.querySelector('[data-bpd-buy-regofficehint]');
    var addrLabel = root.querySelector('[data-bpd-buy-addrlabel]');
    var termsWrap = root.querySelector('[data-bpd-buy-terms]');
    var agreeTEl  = root.querySelector('[data-bpd-buy-agree-terms]');
    var agreeAEl  = root.querySelector('[data-bpd-buy-agree-authority]');
    var termsErr  = root.querySelector('[data-bpd-buy-termserr]');

    /* Which of the linked documents were actually opened. Not a gate — forcing
       someone to click four links to buy a SIM is hostile, and "made
       available" is the standard, not "made unavoidable". But recording it
       costs nothing and turns "the terms were on the page" into something
       answerable per order. */
    var docsOpened = [];
    var docLinks = root.querySelectorAll('[data-bpd-buy-doc]');
    for (var dl = 0; dl < docLinks.length; dl++) {
      docLinks[dl].addEventListener('click', function () {
        var n = this.getAttribute('data-bpd-buy-doc') || '';
        if (n && docsOpened.indexOf(n) === -1) docsOpened.push(n);
      });
    }
    var bankEl    = root.querySelector('[data-bpd-buy-bank]');
    var bankHint  = root.querySelector('[data-bpd-buy-bankhint]');
    var step6Err  = root.querySelector('[data-bpd-buy-step6err]');
    var ports     = root.querySelectorAll('[data-bpd-buy-port]');
    var pacField  = root.querySelector('[data-bpd-buy-pacfield]');
    var pac       = root.querySelector('[data-bpd-buy-pac]');
    var submit    = root.querySelector('[data-bpd-buy-submit]');
    var submitLbl = root.querySelector('[data-bpd-buy-submitlabel]');
    var submitLblText = submitLbl ? submitLbl.textContent : 'Go to checkout';

    var lines = 1;
    var lastFocus = null;
    var leadSent = false;

    /* The pixel Lead is deliberately NOT fired at step 3. Someone who has just
       typed their name is still mid-flow and may yet order — firing there
       reports a conversion for a session whose outcome is not decided, and
       teaches Meta to go and find people who fill in one screen and leave.
       The payload is held here and fired exactly once, when the session
       actually resolves: on a completed order, or on abandonment.

       Internal capture is untouched — sales still gets the contact the moment
       step 3 validates, which is the whole point of capturing there. */
    var pendingLead = null;
    var pixelLeadFired = false;
    /* Minted once at step 3 and reused for every send of this session's Lead
       — pixel and server, first beacon and last. Repeats are free: Meta
       deduplicates on it, so firing on close AND pagehide AND visibilitychange
       still yields exactly one conversion. */
    var leadEventId = null;
    var purchaseEventId = null;

    /* --- partial capture ---------------------------------------------------
       Someone who hands over a name, email and mobile at step 3 and then walks
       away is a lead worth ringing, but until now they only existed in their
       own browser's localStorage — the business never saw them. These send
       that person to the endpoint as a DRAFT order the moment we have contact
       details, and again if they abandon, so sales has a call list.

       partialId is persisted so a reload updates the same draft instead of
       filling the queue with duplicates of one person. */
    var furthestStep = 1;
    var orderPlaced = false;

    function partialUsable() {
      /* Anything we could actually ring or email. The gate has already run by
         the time this matters, but the unload path can fire at any moment. */
      return !orderPlaced && (
        (mobile && looksLikeUkMobile(mobile.value)) ||
        (emailEl && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(emailEl.value.trim()))
      );
    }

    /* ---- Companies House lookup -------------------------------------------
       "Amazon" and "LTD company" both reached a credit check as company names.
       Free text cannot tell you a company exists; the register can.

       Deliberately advisory, not a gate: a company incorporated this week may
       not be listed, the register is occasionally wrong, and a lookup outage
       must never stop an order. Unmatched names still submit — the Worker
       tags them `company-unverified` so the credit team triages before
       spending a search on them. */
    var companyNumber = '';
    /* Limited until told otherwise. The overwhelming majority are, and the
       toggle below is an escape hatch rather than a fork — nobody is made to
       answer a question about their legal structure to get a price. Recorded
       either way: sole traders carry different line limits, and the split is
       worth knowing as data. */
    var businessType = 'limited';

    function syncRegisteredOffice() {
      var limited = businessType === 'limited';
      if (regWrap) regWrap.hidden = !limited;
      /* A sole trader has one address; a limited company has two, and the
         label has to say which is which or we get the home address twice. */
      if (addrLabel) {
        addrLabel.textContent = limited
          ? (root.getAttribute('data-addr-home-label') || 'Your home address')
          : (root.getAttribute('data-addr-label') || addrLabel.textContent);
      }
      if (!limited && regEl) regEl.value = '';
    }

    function setBusinessType(next) {
      if (!soleEl) return;
      businessType = next;
      var sole = next === 'sole_trader';
      var lbl = root.querySelector('label[for="bpd-buy-company"]');
      if (lbl) lbl.textContent = soleEl.getAttribute(sole ? 'data-sole-label' : 'data-limited-label') || lbl.textContent;
      if (companyEl) {
        companyEl.setAttribute('placeholder', soleEl.getAttribute(sole ? 'data-sole-ph' : 'data-limited-ph') || '');
        /* A sole trader has no register entry, so the combobox semantics stop
           being true — leaving them on would have a screen reader announce a
           list of options that can never appear. */
        if (sole) {
          companyEl.removeAttribute('role');
          companyEl.removeAttribute('aria-autocomplete');
          companyEl.removeAttribute('aria-expanded');
          companyEl.setAttribute('autocomplete', 'name');
        } else {
          companyEl.setAttribute('role', 'combobox');
          companyEl.setAttribute('aria-autocomplete', 'list');
          companyEl.setAttribute('aria-expanded', 'false');
          companyEl.setAttribute('autocomplete', 'organization');
        }
      }
      soleEl.textContent = soleEl.getAttribute(sole ? 'data-to-limited' : 'data-to-sole') || '';
      syncRegisteredOffice();
      if (sole) { companyNumber = ''; closeCompanyPicker(); cStatus(''); }
      if (cTimer) { window.clearTimeout(cTimer); cTimer = null; }
    }

    var cTimer = null;
    var COMPANY_ENDPOINT = (document.documentElement.getAttribute('data-bpd-application-endpoint') || '').trim();

    function cStatus(msg) {
      if (!cStatEl) return;
      cStatEl.textContent = msg || '';
      cStatEl.hidden = !msg;
    }
    function closeCompanyPicker() {
      if (!cPickEl) return;
      cPickEl.hidden = true;
      cPickEl.innerHTML = '';
      if (companyEl) companyEl.setAttribute('aria-expanded', 'false');
    }
    function showCompanies(list) {
      if (!cPickEl) return;
      cPickEl.innerHTML = '';
      if (!list.length) { closeCompanyPicker(); return; }
      for (var i = 0; i < list.length; i++) {
        (function (c) {
          var li = document.createElement('li');
          var b  = document.createElement('button');
          b.type = 'button';
          b.setAttribute('role', 'option');
          var nm = document.createElement('b');
          nm.textContent = c.name;
          var meta = document.createElement('span');
          meta.className = 'bpd-buy__cpick-meta';
          var closed = c.status && c.status !== 'active';
          meta.textContent = c.number + (c.address ? ' \u00b7 ' + c.address : '');
          b.appendChild(nm); b.appendChild(meta);
          /* Status matters: a dissolved company cannot take a contract, and
             showing it saves the credit team finding out later. It sits
             OUTSIDE the meta line on purpose — that line is clipped to one
             row on a phone, and a status tucked on the end would be the first
             thing the ellipsis ate. */
          if (closed) {
            var st = document.createElement('span');
            st.className = 'is-closed';
            st.textContent = c.status.replace(/-/g, ' ');
            b.appendChild(st);
          }
          b.addEventListener('click', function () {
            companyEl.value = c.name;
            companyNumber = c.number;
            /* Pre-filled, not forced: registering at an accountant's address
               and trading elsewhere is normal, and they can correct it. */
            if (regEl && c.address) {
              regEl.value = c.address;
              if (regHint) regHint.hidden = false;
            }
            closeCompanyPicker();
            cStatus('Matched \u2014 company ' + c.number + (closed ? ' (' + c.status.replace(/-/g,' ') + ')' : ''));
            qualified(c.number, c.name);
          });
          li.appendChild(b);
          cPickEl.appendChild(li);
        })(list[i]);
      }
      cPickEl.hidden = false;
      if (companyEl) companyEl.setAttribute('aria-expanded', 'true');
    }
    function searchCompanies(q) {
      if (!COMPANY_ENDPOINT || q.length < 3) { closeCompanyPicker(); return; }
      cStatus('Searching Companies House\u2026');
      fetch(COMPANY_ENDPOINT.replace(/\/$/, '') + '/company?q=' + encodeURIComponent(q), { mode: 'cors', credentials: 'omit' })
        .then(function (r) { return r && r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || !d.results || !d.results.length) { closeCompanyPicker(); cStatus(''); return; }
          cStatus('');
          showCompanies(d.results);
        })
        .catch(function () { closeCompanyPicker(); cStatus(''); });
    }
    if (nameEl) nameEl.addEventListener('input', function () { directorChecked = false; });
    if (companyEl) {
      companyEl.addEventListener('input', function () {
        /* Typing invalidates a previous match — otherwise someone picks a
           company, edits the name, and the order carries a number that no
           longer belongs to it. */
        companyNumber = '';
        directorChecked = false;
        cStatus('');
        window.clearTimeout(cTimer);
        var q = companyEl.value.trim();
        if (businessType === 'limited')
          cTimer = window.setTimeout(function () { searchCompanies(q); }, 320);
      });

    syncRegisteredOffice();
    if (soleEl) {
      soleEl.addEventListener('click', function () {
        setBusinessType(businessType === 'limited' ? 'sole_trader' : 'limited');
        if (companyEl) companyEl.focus();
      });
    }
      companyEl.addEventListener('blur', function () {
        /* Delayed so a click on a result lands before the list closes. */
        window.setTimeout(closeCompanyPicker, 180);
      });
    }

    /* The same four fields passesGate() demands, checked without touching the
       DOM or showing errors. */
    function gateDataComplete() {
      return !!(companyEl && companyEl.value.trim().length >= 2 &&
                nameEl && nameEl.value.trim().split(/\s+/).length >= 2 &&
                titleEl && titleEl.value !== '' &&
                emailEl && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(emailEl.value.trim()) &&
                mobile && looksLikeUkMobile(mobile.value));
    }

    function sendPartial(reason, beacon) {
      if (!partialUsable()) return;

      /* Someone who fills step 3 and closes WITHOUT pressing Next never runs
         passesGate, so they had no event id and no held payload — they reached
         the sales queue via the partial below but were reported to Meta as
         nothing at all. They are a lead by every measure that matters here, so
         mint for them too. The bar is deliberately the SAME four fields the
         gate demands: this fixes who gets counted, not what counts. */
      if (gateDataComplete()) {
        leadEventId = leadEventId || newEventId();
        pendingLead = pendingLead || { content_name: 'buy_flow', currency: 'GBP' };
        pendingLead.value = perLine * lines;
        pendingLead.num_items = lines;
      }
      /* Contact and deal size ONLY. Never dob/sortEl/acctEl — an unfinished
         application is not consent, and half-typed bank details have no place
         in a sales queue. */
      var fb = fbIdentity();
      postPartial({
        source: 'buy_flow',
        reason: reason,
        furthestStep: furthestStep,
        /* For the server-side send. `reason` is what tells the Worker whether
           this session has resolved yet — it must not report a Lead for
           someone still filling the form in. */
        eventId: leadEventId,
        fbc: fb.fbc,
        fbp: fb.fbp,
        pageUrl: location.href,
        company: companyEl ? companyEl.value.trim() : '',
        /* Public register data, so it is safe on a partial — and it lets sales
           see whether the company checks out before they pick up the phone. */
        companyNumber: companyNumber,
        businessType: businessType,
        mobileToken: mobileToken,
        name: nameEl ? nameEl.value.trim() : '',
        email: emailEl ? emailEl.value.trim() : '',
        mobile: mobile ? normaliseMobile(mobile.value) : '',
        lines: lines,
        sim: chosenSim(),
        variantId: idInput ? Number(idInput.value) : null,
        quantity: lines,
        cashback: perLine * lines,
        cashbackPerLine: perLine
      }, beacon);
    }

    function setTxt(sel, v) {
      var n = root.querySelectorAll(sel);
      for (var i = 0; i < n.length; i++) n[i].textContent = v;
    }
    function chosenSim() {
      for (var i = 0; i < sims.length; i++) if (sims[i].checked) return sims[i].value;
      return sims.length ? sims[0].value : '';
    }
    function porting() {
      for (var i = 0; i < ports.length; i++) if (ports[i].checked) return ports[i].value === 'yes';
      return false;
    }

    /* Variant lookup is by option value, so the block strings must match the
       product's real options. No match means we keep the current id rather
       than posting a broken one to the cart. */
    function resolveVariant(value) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var opts = v.options || [v.option1, v.option2, v.option3];
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] && String(opts[j]).toLowerCase() === String(value).toLowerCase()) {
            return v.available === false ? null : v.id;
          }
        }
      }
      return null;
    }

    function render() {
      lines = Math.min(maxLines, Math.max(1, lines));
      if (range) { range.value = lines; paintRange(range); }
      if (qtyInput) qtyInput.value = String(lines);

      var cash = perLine * lines;
      var unit = (variants[0] && variants[0].price ? variants[0].price / 100 : 19.95);
      var sim  = chosenSim();

      setTxt('[data-bpd-buy-lines]', String(lines));
      setTxt('[data-bpd-buy-lineword]', lines === 1 ? 'line' : 'lines');
      setTxt('[data-bpd-buy-cash]', money(cash));

      setTxt('[data-bpd-buy-sumlines]', lines + (lines === 1 ? ' line' : ' lines') + ' × ' + money(unit));
      setTxt('[data-bpd-buy-summonthly]', money(unit * lines) + '/mo');
      setTxt('[data-bpd-buy-sumsim]', sim);
      setTxt('[data-bpd-buy-sumcash]', money(cash));

      var pacRow = root.querySelector('[data-bpd-buy-sumpacrow]');
      if (pacRow) {
        pacRow.hidden = !porting();
        var code = pac && pac.value.trim() ? pac.value.trim().toUpperCase() : 'PAC to follow';
        setTxt('[data-bpd-buy-sumpac]', code);
      }
      if (pacField) pacField.hidden = !porting();

      var id = resolveVariant(sim);
      if (id && idInput) idInput.value = String(id);
      if (submit) submit.disabled = !id;

      if (propMob && mobile) propMob.value = normaliseMobile(mobile.value);
      if (propPac) propPac.value = porting() ? (pac ? pac.value.trim().toUpperCase() : '') : '';
    }

    /* Fires the held Lead once, when the outcome is known. The resolution is
       recorded so both cases stay legible in reporting: an order is a lead as
       well, an abandon is a lead and nothing more. */
    function flushPixelLead(resolution) {
      if (!pendingLead || pixelLeadFired) return;
      pixelLeadFired = true;
      pendingLead.content_category = resolution;
      track('Lead', pendingLead, leadEventId);
    }

    function show(n) {
      var steps = root.querySelectorAll('[data-bpd-buy-step]');
      for (var i = 0; i < steps.length; i++) {
        steps[i].hidden = steps[i].getAttribute('data-bpd-buy-step') !== String(n);
      }
      var dots = root.querySelectorAll('[data-bpd-buy-dot]');
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is-on', parseInt(dots[d].getAttribute('data-bpd-buy-dot'), 10) <= n);
      }
      if (n > furthestStep) furthestStep = n;
      var head = root.querySelector('[data-bpd-buy-step="' + n + '"] .bpd-buy__q');
      if (head) { head.setAttribute('tabindex', '-1'); head.focus({ preventScroll: true }); }
      track('BuyStep' + n, { content_name: 'buy_flow', num_items: lines });
    }

    /* The gate. A valid UK mobile is what unlocks everything after step 3,
       and it is also where the lead is captured — so an abandoned checkout
       still leaves a number the team can call. */
    function fail(el, errEl, msg) {
      if (errEl) { errEl.textContent = msg; errEl.hidden = false; }
      if (el) { el.classList.add('is-invalid'); el.focus(); }
      return false;
    }
    function clearErr(errEl) { if (errEl) errEl.hidden = true; }

    /* Step three is the gate: name, email and a valid UK mobile. Nothing past
       it is reachable without them, and it is where the lead is captured — so
       an abandon still leaves the team someone to contact. */
    /* ---- mobile verification -------------------------------------------
       An interstitial between step 3 and step 4, not a field on step 3. The
       customer completes the step they understand, presses Next, and then
       gets one screen asking for one thing — which is both a better ask and
       a clearer signal that the number genuinely matters to us.

       Verification gates progress only when it is actually available: if
       Twilio is unconfigured or the send fails, the flow continues rather
       than trapping someone behind a code that will never arrive. Fewer
       leads is the goal; zero leads is not. */
    var mobileToken = '';
    var verifiedNumber = '';
    var otpReturnStep = 4;

    function otpStatus(msg, bad) {
      if (!otpStat) return;
      otpStat.textContent = msg || '';
      otpStat.hidden = !msg;
      otpStat.classList.toggle('is-warn', !!bad);
    }
    function otpEndpoint(path) {
      var base = (document.documentElement.getAttribute('data-bpd-application-endpoint') || '').trim();
      return base ? base.replace(/\/$/, '') + path : '';
    }
    function otpPanelShow(on) {
      if (!otpPanel) return;
      otpPanel.hidden = !on;
      var step3 = root.querySelector('[data-bpd-buy-step="3"]');
      if (step3) step3.hidden = !!on;
      if (on && otpInput) { otpInput.value = ''; otpInput.focus(); }
    }
    function otpSend(quiet) {
      var url = otpEndpoint('/otp/send');
      if (!url || !mobile) return Promise.resolve(false);
      if (!quiet) otpStatus('Sending\u2026');
      return fetch(url, { method: 'POST', mode: 'cors', credentials: 'omit',
                   headers: { 'Content-Type': 'application/json' },
                   body: JSON.stringify({ mobile: normaliseMobile(mobile.value) }) })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.ok) { otpStatus('Code sent. It expires in 10 minutes.'); return true; }
          otpStatus((d && d.error) || 'Could not send a code.', true);
          return false;
        })
        .catch(function () { otpStatus('Could not send a code.', true); return false; });
    }
    function otpVerify() {
      var url = otpEndpoint('/otp/verify');
      if (!url || !otpInput) return;
      otpStatus('Checking\u2026');
      fetch(url, { method: 'POST', mode: 'cors', credentials: 'omit',
                   headers: { 'Content-Type': 'application/json' },
                   body: JSON.stringify({ mobile: normaliseMobile(mobile.value), code: otpInput.value }) })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.ok && d.token) {
            mobileToken = d.token;
            verifiedNumber = normaliseMobile(mobile.value);
            otpStatus('');
            otpPanelShow(false);
            show(otpReturnStep);
          } else {
            otpStatus((d && d.error) || 'That code is not right.', true);
            if (otpInput) { otpInput.value = ''; otpInput.focus(); }
          }
        })
        .catch(function () { otpStatus('Could not check that code. Please try again.', true); });
    }
    if (otpInput) otpInput.addEventListener('input', function () {
      otpInput.value = otpInput.value.replace(/\D/g, '');
      if (otpInput.value.length === 6) otpVerify();   // six digits IS the submit
    });
    if (otpResend) otpResend.addEventListener('click', function () { otpSend(); });
    if (otpBack) otpBack.addEventListener('click', function () {
      otpPanelShow(false);
      show(3);
      if (mobile) mobile.focus();
    });

    /* ---- "which company is yours?" ---------------------------------------
       The company picker searches Companies House by COMPANY name, so it
       fails everyone who does not know their registered name. Order #1250
       typed her own name into the box, matched nothing, and was tagged
       unqualified.

       Companies House also indexes officers, so once we have a name AND a
       date of birth we can look up their live directorships and offer them.
       The date of birth is not optional: "Victoria Best" alone returns five
       different real people in Poole, Warrington, Reading, Omagh and East
       Grinstead, and offering a stranger's company would be far worse than
       offering nothing. The Worker refuses to search without one.

       Runs after step 4, because that is the first point a date of birth
       exists. Finds nothing for most people and costs them nothing. */
    var wcoNextStep = 5;

    function wcoShow(on) {
      if (!wcoPanel) return;
      wcoPanel.hidden = !on;
      var step4 = root.querySelector('[data-bpd-buy-step="4"]');
      if (step4) step4.hidden = !!on;
      if (on) {
        var head = wcoPanel.querySelector('.bpd-buy__q');
        if (head) { head.setAttribute('tabindex', '-1'); head.focus({ preventScroll: true }); }
      }
    }

    function wcoRender(list) {
      if (!wcoList) return;
      wcoList.textContent = '';
      if (wcoIntro) {
        wcoIntro.textContent = list.length === 1
          ? 'Companies House has you listed as a director here. Choose it if this is the business you are ordering for.'
          : 'Companies House has you listed as a director of these. Choose the business you are ordering for.';
      }
      for (var i = 0; i < list.length; i++) {
        (function (c) {
          var li = document.createElement('li');
          var b = document.createElement('button');
          b.type = 'button';
          var nm = document.createElement('b');
          nm.textContent = c.name;
          b.appendChild(nm);
          if (c.address) {
            var meta = document.createElement('span');
            meta.className = 'bpd-buy__cpick-meta';
            meta.textContent = c.address;
            b.appendChild(meta);
          }
          b.addEventListener('click', function () {
            if (companyEl) companyEl.value = c.name;
            companyNumber = c.number;
            cStatus('Matched — company ' + c.number);
            qualified(c.number, c.name);
            wcoShow(false);
            show(wcoNextStep);
          });
          li.appendChild(b);
          wcoList.appendChild(li);
        })(list[i]);
      }
    }

    /* Resolves true when the panel has been shown and is now driving the flow,
       false when there is nothing to offer and the caller should just carry on.
       Every failure path resolves false: a lookup that errors, times out or
       returns nothing must never stand between a customer and their order. */
    function wcoOffer() {
      if (!wcoPanel || !wcoList) return Promise.resolve(false);
      if (businessType !== 'limited' || companyNumber) return Promise.resolve(false);
      var url = otpEndpoint('/officer');
      var who = nameEl ? nameEl.value.trim() : '';
      var born = dob ? dob.value : '';
      if (!url || who.length < 3 || !born) return Promise.resolve(false);
      /* Next now waits on this, so a lookup that hangs would leave the
         customer pressing a button that does nothing — the same dead end the
         verification panel produced. Two calls to Companies House take well
         under a second; anything past 3s is treated as "nothing to offer"
         and the flow moves on regardless of what the network does later. */
      var raced = false;
      var timeout = new Promise(function (resolve) {
        window.setTimeout(function () { raced = true; resolve(null); }, 3000);
      });
      var lookup = fetch(url + '?name=' + encodeURIComponent(who) + '&dob=' + encodeURIComponent(born),
                   { mode: 'cors', credentials: 'omit' })
        .then(function (r) { return r && r.ok ? r.json() : null; });
      return Promise.race([lookup, timeout])
        .then(function (d) { return raced ? null : d; })
        .then(function (d) {
          if (!d || !d.results || !d.results.length) return false;
          wcoRender(d.results.slice(0, 5));
          wcoShow(true);
          return true;
        })
        .catch(function () { return false; });
    }

    if (wcoSkip) wcoSkip.addEventListener('click', function () {
      wcoShow(false);
      show(wcoNextStep);
    });

    /* ---- is this person a director of that company? ----------------------
       Kane, 21 Sep: 11 of his last 30 had a name nowhere near the company's
       register entry. He cannot credit check those, and each one costs him
       the time to look it up and reject it by hand.

       Checked at step 3, where both the company and the name are on screen,
       so the customer can fix it themselves — a typo, a married name, or the
       wrong company picked from the list. Never a silent block: the message
       says what we found and offers the three honest ways out.

       Fails OPEN. A slow or broken lookup must not stop an order. */
    var directorAckKey = '';
    var directorChecked = false;

    function directorCheck() {
      if (businessType !== 'limited' || !companyNumber) return Promise.resolve(false);
      var who = nameEl ? nameEl.value.trim() : '';
      var key = companyNumber + '|' + who.toLowerCase();
      var base = (document.documentElement.getAttribute('data-bpd-application-endpoint') || '').trim();
      if (!base || who.length < 3 || key === directorAckKey) return Promise.resolve(false);

      var timedOut = false;
      var timer = new Promise(function (resolve) {
        window.setTimeout(function () { timedOut = true; resolve(null); }, 4000);
      });
      var look = fetch(base.replace(/\/$/, '') + '/company?number=' + encodeURIComponent(companyNumber) +
                       '&name=' + encodeURIComponent(who), { mode: 'cors', credentials: 'omit' })
        .then(function (r) { return r && r.ok ? r.json() : null; });

      return Promise.race([look, timer]).then(function (d) {
        if (timedOut || !d || !d.company) return false;
        var c = d.company;
        if (c.directorMatch !== false) return false;         // matched, or unknown — let them through
        directorAckKey = key;
        fail(nameEl, gateErr,
          'We could not find ' + who + ' listed as a director of ' +
          (c.registeredName || 'that company') + ' at Companies House. ' +
          'Please use your name as it appears on the register, pick the right company above, or ' +
          'switch to sole trader if the account is not in the company\'s name.');
        return true;
      }).catch(function () { return false; });
    }

    function passesGate() {
      clearErr(gateErr);
      [companyEl, titleEl, nameEl, emailEl, mobile].forEach(function (el) { if (el) el.classList.remove('is-invalid'); });

      /* The company is the party the agreement binds and the name the credit
         check is run against — an order without it cannot be onboarded. */
      if (!companyEl || companyEl.value.trim().length < 2)
        return fail(companyEl, gateErr, 'Please give us the company name.');
      if (!nameEl || nameEl.value.trim().length < 2)
        return fail(nameEl, gateErr, 'Please give us the name for the account.');
      /* Vodafone refuse a credit check on a contact with only one name —
         "Primary finance contact Salutation, Firstname and Lastname required"
         on order #1539 — so it is caught here rather than three steps later. */
      if (nameEl.value.trim().split(/\s+/).length < 2)
        return fail(nameEl, gateErr, 'Please give us a first name and a surname.');
      if (titleEl && titleEl.value === '')
        return fail(titleEl, gateErr, 'Please choose a title — the credit check needs one.');
      if (!emailEl) return fail(emailEl, gateErr, 'That email address does not look right.');
      var emailMsg = emailMessage(emailEl.value);
      if (emailMsg) return fail(emailEl, gateErr, emailMsg);

      /* Kane, 15 Sep: four orders said "limited company" with no company at
         all behind them. Picking from the register is what makes the credit
         search possible, so it is required — with the honest way out named in
         the same breath, because plenty of them are sole traders who picked
         the wrong option. */
      if (businessType === 'limited' && !companyNumber) {
        return fail(companyEl, gateErr,
          'Please choose your company from the list so we can look it up. ' +
          'If you are not a limited company, tap "' +
          ((soleEl && soleEl.textContent.trim()) || 'I am a sole trader') + '" above.');
      }

      var ok = mobile && looksLikeUkMobile(mobile.value);
      if (!ok) return fail(mobile, gateErr, 'That does not look like a UK mobile. It should start 07 and be 11 digits.');


      if (ok && !leadSent) {
        leadSent = true;
        var lead = rememberLead({
          company: companyEl ? companyEl.value.trim() : '',
          name: nameEl.value.trim(),
          email: emailEl.value.trim(),
          mobile: normaliseMobile(mobile.value),
          callConsent: false,          // no tickbox — screen against TPS/CTPS
          consentAt: new Date().toISOString(),
          source: 'buy_flow',
          lines: lines,
          cashback: perLine * lines,
          monthly: +((variants[0] && variants[0].price ? variants[0].price / 100 : 19.95) * lines).toFixed(2),
        });
        leadEventId = leadEventId || newEventId();
        pendingLead = {
          content_name: 'buy_flow', value: perLine * lines,
          currency: 'GBP', num_items: lines,
        };
        document.dispatchEvent(new CustomEvent('bpd:lead', { detail: lead }));
        sendLead(lead);
        /* Contact details are in hand — bank this person now, before they
           reach the steps most people drop at. */
        sendPartial('reached step 3', false);
      }
      return !!ok;
    }

    /* ---- address lookup ---------------------------------------------------
       Typing a full address on a phone keyboard is the heaviest ask in this
       flow, and step 4 is where people drop. Two tiers, both optional, and
       hand-typing always works:

       1. postcodes.io — free, no key, no licence. Confirms the postcode is
          real and returns the town. That alone catches transposed characters
          before they reach a credit check, where a bad address is a decline.

       2. A full address list needs Royal Mail PAF data, which is licensed and
          paid. When `data-bpd-address-endpoint` is set it is called for the
          list; it is expected to proxy whichever provider you buy (getAddress,
          Ideal Postcodes, Loqate) so the API key stays server-side rather
          than sitting in this file, which is public.

       Failure is always silent and non-blocking — a lookup being down must
       never stop someone ordering. */
    var knownTown = '';
    var findBtn   = root.querySelector('[data-bpd-buy-findaddr]');
    var addrStat  = root.querySelector('[data-bpd-buy-addrstatus]');
    var pickWrap  = root.querySelector('[data-bpd-buy-addrpickwrap]');
    var pickEl    = root.querySelector('[data-bpd-buy-addrpick]');
    var ADDR_ENDPOINT = (document.documentElement.getAttribute('data-bpd-address-endpoint') || '').trim();

    function normalisePostcode(v) {
      var raw = String(v || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
      if (raw.length < 5 || raw.length > 7) return null;
      return raw.slice(0, raw.length - 3) + ' ' + raw.slice(-3);
    }

    function setAddrStatus(msg, isError) {
      if (!addrStat) return;
      addrStat.textContent = msg || '';
      addrStat.hidden = !msg;
      addrStat.classList.toggle('is-error', !!isError);
    }

    function showAddressOptions(list) {
      if (!pickEl || !pickWrap || !list || !list.length) return false;
      pickEl.innerHTML = '';
      var ph = document.createElement('option');
      ph.value = ''; ph.textContent = list.length + ' addresses — choose yours';
      pickEl.appendChild(ph);
      list.forEach(function (line) {
        var o = document.createElement('option');
        o.value = line; o.textContent = line;
        pickEl.appendChild(o);
      });
      pickWrap.hidden = false;
      return true;
    }

    if (pickEl) pickEl.addEventListener('change', function () {
      if (!pickEl.value || !addrEl) return;
      addrEl.value = pickEl.value;
      addrEl.dispatchEvent(new Event('input', { bubbles: true }));
      addrEl.classList.remove('is-invalid');
    });

    function lookupAddress() {
      if (!postEl) return;
      var pc = normalisePostcode(postEl.value);
      if (!pc) {
        setAddrStatus('That postcode does not look complete.', true);
        postEl.classList.add('is-invalid');
        return;
      }
      postEl.value = pc;                       // tidy the formatting while we are here
      postEl.classList.remove('is-invalid');
      setAddrStatus('Looking it up…');
      if (findBtn) findBtn.disabled = true;

      var done = function () { if (findBtn) findBtn.disabled = false; };

      /* Full list first when configured, otherwise straight to validation. */
      var full = ADDR_ENDPOINT
        ? fetch(ADDR_ENDPOINT + (ADDR_ENDPOINT.indexOf('?') > -1 ? '&' : '?') + 'postcode=' + encodeURIComponent(pc),
                { mode: 'cors', credentials: 'omit' })
            .then(function (r) { return r && r.ok ? r.json() : null; })
            .then(function (d) { return d && d.addresses && d.addresses.length ? d.addresses : null; })
            .catch(function () { return null; })
        : Promise.resolve(null);

      full.then(function (list) {
        if (showAddressOptions(list)) {
          setAddrStatus('Pick your address below, or type it in.');
          done();
          return;
        }
        /* No list — still confirm the postcode is real and name the town, so
           the customer knows we recognised it. */
        return fetch('https://api.postcodes.io/postcodes/' + encodeURIComponent(pc.replace(/\s/g, '')))
          .then(function (r) { return r && r.ok ? r.json() : null; })
          .then(function (d) {
            var res = d && d.result;
            if (!res) {
              setAddrStatus('We could not find that postcode. Check it, or type your address below.', true);
              postEl.classList.add('is-invalid');
            } else {
              /* postcodes.io does NOT return post_town — the field is null.
                 `admin_district` is the LOCAL AUTHORITY, not the postal town,
                 and using it shows people the wrong place: PO15 7FN comes back
                 "Winchester" when the postal town is Fareham. Parish and ward
                 are accurate for the locality ("Whiteley"), so use those and
                 call it an area rather than asserting a town we do not have. */
              var area = res.parish && !/unparished/i.test(res.parish)
                ? res.parish
                : (res.admin_ward || '');
              knownTown = area;
              setAddrStatus(area
                ? ('Found — ' + area + '. Now add your house number and street below.')
                : 'Postcode found. Now add your house number and street below.');
              if (addrEl) addrEl.focus();
            }
            done();
          })
          .catch(function () { setAddrStatus(''); done(); });
      });
    }

    if (findBtn) findBtn.addEventListener('click', lookupAddress);
    if (postEl) postEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); lookupAddress(); }
    });

    /* Vodafone want three years and count it themselves, so the form counts
       it the same way and keeps asking until it is covered. Three years at the
       current address settles it in one; anything shorter adds a row, and so
       does each row that does not finish the job. Nobody who has been at their
       current address three years or more sees any of this. */
    function prevRowList() {
      return prevRows ? [].slice.call(prevRows.querySelectorAll('[data-bpd-buy-prevrow]')) : [];
    }

    /* Whole months between a "YYYY-MM" and today. */
    function monthsSince(ym) {
      if (!/^\d{4}-\d{2}$/.test(String(ym || ''))) return null;
      var p = ym.split('-'), now = new Date();
      return (now.getFullYear() - parseInt(p[0], 10)) * 12 +
             (now.getMonth() + 1 - parseInt(p[1], 10));
    }

    function addPrevRow() {
      if (!prevTmpl || !prevRows) return null;
      var row = prevTmpl.content.firstElementChild.cloneNode(true);
      prevRows.appendChild(row);
      var n = row.querySelector('[data-bpd-buy-prevnum]');
      if (n) n.textContent = prevRowList().length > 1 ? '(' + prevRowList().length + ')' : '';
      var m = row.querySelector('[data-bpd-buy-prevmovedin]');
      m.max = thisMonth();
      m.addEventListener('change', syncAddressHistory);
      return row;
    }

    function thisMonth() {
      var d = new Date();
      return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0');
    }

    /* The oldest move-in date on the form is where the history starts, so the
       cover is simply how long ago that was. Dates, not bands, so there is
       nothing to round. */
    function coveredMonths() {
      var oldest = monthsSince(movedIn ? movedIn.value : '');
      prevRowList().forEach(function (row) {
        var m = monthsSince(row.querySelector('[data-bpd-buy-prevmovedin]').value);
        if (m !== null && (oldest === null || m > oldest)) oldest = m;
      });
      return oldest === null ? 0 : oldest;
    }

    function syncAddressHistory() {
      var at = monthsSince(movedIn ? movedIn.value : '');
      var needsPrev = at !== null && at < 36;
      if (prevWrap) prevWrap.hidden = !needsPrev;
      if (!needsPrev) { if (prevRows) prevRows.innerHTML = ''; return false; }

      if (!prevRowList().length) addPrevRow();
      /* One more row only once the last one has been answered, so the form
         never grows a wall of empty boxes in front of somebody. */
      var rows = prevRowList();
      var last = rows[rows.length - 1];
      var lastAnswered = last && last.querySelector('[data-bpd-buy-prevmovedin]').value !== '';
      if (coveredMonths() < 36 && lastAnswered && rows.length < 5) addPrevRow();

      if (prevHint) {
        var short = 36 - coveredMonths();
        /* Five addresses and still short means somebody has moved a lot. Five
           boxes and no way forward is a dead end, so we take what they have
           and the desk picks the rest up on the call — a captured order beats
           a customer stuck on step four. */
        prevHint.textContent = short <= 0 ? 'That covers the three years we need.'
          : prevRowList().length >= 5
            ? 'That is as many as we need here — we will pick up the rest when we call you.'
            : 'Credit checks need three years of address history — ' + short + ' more ' +
              (short === 1 ? 'month' : 'months') + ' to go.';
      }
      return true;
    }

    function passesStep4() {
      clearErr(step4Err);
      [dob, addrEl, postEl, movedIn].concat(
        prevRows ? [].slice.call(prevRows.querySelectorAll('input, select')) : []
      ).forEach(function (el) { if (el) el.classList.remove('is-invalid'); });
      if (!dob || !dob.value) return fail(dob, step4Err, 'We need a date of birth for the credit check.');
      /* A date input accepts anything typed, including year 4000 — min/max
         only bound the picker. Check it's a real date, then that the age is
         plausible, with a message for each case rather than one catch-all. */
      var born = Date.parse(dob.value);
      if (isNaN(born)) return fail(dob, step4Err, 'That date does not look right.');
      var yrs = (Date.now() - born) / 31557600000;
      if (yrs < 0)   return fail(dob, step4Err, 'That date is in the future.');
      if (yrs < 18)  return fail(dob, step4Err, 'You need to be 18 or over to take out a business mobile agreement.');
      if (yrs > 100) return fail(dob, step4Err, 'Please check the year — that date is over 100 years ago.');
      if (!addrEl || addrEl.value.trim().length < 4)
        return fail(addrEl, step4Err, 'Please add your home address.');
      // loose UK postcode shape — Royal Mail validates properly downstream
      if (!postEl || !/^[A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2}$/i.test(postEl.value.trim()))
        return fail(postEl, step4Err, 'That postcode does not look right.');
      if (!movedIn || monthsSince(movedIn.value) === null)
        return fail(movedIn, step4Err, 'Please tell us the month you moved in.');
      if (monthsSince(movedIn.value) < 0)
        return fail(movedIn, step4Err, 'That month is in the future.');
      if (syncAddressHistory()) {
        var rows = prevRowList();
        for (var i = 0; i < rows.length; i++) {
          var a = rows[i].querySelector('[data-bpd-buy-prevaddr]');
          var pc = rows[i].querySelector('[data-bpd-buy-prevpostcode]');
          var yr = rows[i].querySelector('[data-bpd-buy-prevmovedin]');
          /* The last row is allowed to be empty once the three years are
             already covered — it is the spare one the form offered, not one
             anybody has to fill in. */
          var blank = !a.value.trim() && !pc.value.trim() && yr.value === '';
          if (blank && i === rows.length - 1 && coveredMonths() >= 36) continue;
          if (a.value.trim().length < 6) {
            /* Being told "add the previous address" again, right after adding
               one, reads like the form ignored you. Say what is actually
               being asked for: the address before the one just given. */
            var short = 36 - coveredMonths();
            return fail(a, step4Err, i === 0
              ? 'Please add the previous address.'
              : 'We need the address before that one — ' + short + ' more ' +
                (short === 1 ? 'month' : 'months') + ' to reach the three years credit checks need.');
          }
          /* Vodafone reject a history entry with no postcode of its own. */
          if (!/^[A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2}$/i.test(pc.value.trim()))
            return fail(pc, step4Err, 'That postcode does not look right.');
          if (monthsSince(yr.value) === null)
            return fail(yr, step4Err, 'Please tell us the month you moved in there.');
        }
        if (coveredMonths() < 36 && prevRowList().length < 5)
          return fail(null, step4Err, 'Credit checks need three years of address history — please add the address before that one.');
      }
      return true;
    }

    /* Shape check only — the bank validates properly when the mandate is set
       up. A modulus check here would reject valid edge cases and help nobody. */
    /* Sort code -> bank, so nobody has to answer a question their own card
       already answers. Deliberately partial: only prefixes that are not shared
       between brands are listed, because the authoritative source is Pay.UK's
       licensed sort code directory and a confident-but-wrong bank name on a
       credit check is worse than an empty box. Anything not here stays blank
       and the customer types it.

       77xx is omitted on purpose — it is split between Lloyds and TSB. */
    var BANKS = {
      '01':'NatWest', '07':'Nationwide Building Society', '08':'The Co-operative Bank',
      '09':'Santander UK', '11':'Halifax', '12':'Bank of Scotland',
      '15':'Royal Bank of Scotland', '16':'Royal Bank of Scotland',
      '20':'Barclays', '30':'Lloyds Bank', '40':'HSBC UK',
      '50':'NatWest', '51':'NatWest', '52':'NatWest', '53':'NatWest',
      '54':'NatWest', '55':'NatWest', '56':'NatWest', '57':'NatWest',
      '60':'NatWest', '62':'NatWest',
      '80':'Bank of Scotland', '82':'Virgin Money', '83':'Royal Bank of Scotland',
      '87':'TSB Bank'
    };
    /* The app banks all sit under 04, so they only separate at six digits —
       a four-digit key made '0400' swallow Starling's 04-00-75 into Monzo. */
    var BANKS6 = {
      '040003':'Monzo', '040004':'Monzo',
      '040075':'Starling Bank', '040076':'Starling Bank',
      '231470':'Wise'
    };
    function bankFromSort(v) {
      var d = String(v || '').replace(/\D/g,'');
      if (d.length >= 6 && BANKS6[d.slice(0,6)]) return BANKS6[d.slice(0,6)];
      /* 04 without a known six-digit match is left blank rather than guessed:
         the prefix is shared and there is no safe default. */
      if (d.slice(0,2) === '04') return '';
      if (d.length < 2) return '';
      return BANKS[d.slice(0,2)] || '';
    }

    /* Fill as they type, but never overwrite something they typed themselves —
       a guess must not clobber a correction. */
    var bankTouched = false;
    if (bankEl) bankEl.addEventListener('input', function () { bankTouched = true; if (bankHint) bankHint.hidden = true; });
    if (sortEl && bankEl) sortEl.addEventListener('input', function () {
      if (bankTouched) return;
      var guess = bankFromSort(sortEl.value);
      bankEl.value = guess;
      if (bankHint) bankHint.hidden = !guess;
    });

    /* Modulus check, on blur rather than on every keystroke: mid-typing the
       number is always invalid, and flashing a warning at someone who is
       still typing trains them to ignore it.

       A warning only. Building society roll-number accounts and a few newer
       providers legitimately fail the check, and the endpoint returns
       "unchecked" for anything it cannot rule on — so nothing here blocks an
       order, it just gets the typo fixed while the customer can still fix it. */
    function bankStatus(msg, bad) {
      if (!acctStEl) return;
      acctStEl.textContent = msg || '';
      acctStEl.hidden = !msg;
      acctStEl.classList.toggle('is-warn', !!bad);
      if (acctEl) acctEl.classList.toggle('is-invalid', !!bad);
    }
    function checkBankDetails() {
      if (!sortEl || !acctEl || !acctStEl) return;
      var sort = sortEl.value.replace(/\D/g, '');
      var acct = acctEl.value.replace(/\D/g, '');
      if (sort.length !== 6 || acct.length < 6) { bankStatus(''); return; }
      var base = (document.documentElement.getAttribute('data-bpd-application-endpoint') || '').trim();
      if (!base) return;
      fetch(base.replace(/\/$/, '') + '/bank?sort=' + encodeURIComponent(sort) + '&account=' + encodeURIComponent(acct),
            { mode: 'cors', credentials: 'omit' })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (!d || !d.checked) { bankStatus(''); return; }   // unknown: say nothing
          bankStatus(d.pass ? '' : 'Please double-check this account number \u2014 it does not look right for that sort code.', !d.pass);
        })
        .catch(function () { bankStatus(''); });
    }
    if (acctEl) acctEl.addEventListener('blur', checkBankDetails);
    if (sortEl) sortEl.addEventListener('blur', checkBankDetails);

    /* ── Two mistakes real customers made, caught while they can still fix
       them ──────────────────────────────────────────────────────────────
       Order #1266 gave us "hotmail.con" and #1268 typed "Barclays" as the
       name on the account. Both passed every gate we had; both make the
       order unworkable downstream. The form is the only place either can be
       corrected for free. */

    var DOMAIN_TYPOS = {
      'gmial.com': 'gmail.com', 'gmai.com': 'gmail.com', 'gmil.com': 'gmail.com',
      'gamil.com': 'gmail.com', 'gnail.com': 'gmail.com', 'gmaill.com': 'gmail.com',
      'gmail.co': 'gmail.com', 'gmail.cm': 'gmail.com',
      'hotmial.com': 'hotmail.com', 'hotmai.com': 'hotmail.com',
      'hotmall.com': 'hotmail.com', 'hotmil.com': 'hotmail.com',
      'hotamail.com': 'hotmail.com', 'hotmail.co': 'hotmail.com',
      'outlok.com': 'outlook.com', 'outloo.com': 'outlook.com',
      'outlook.co': 'outlook.com', 'outook.com': 'outlook.com',
      'yaho.com': 'yahoo.com', 'yahou.com': 'yahoo.com', 'yahoo.co': 'yahoo.com',
      'iclould.com': 'icloud.com', 'iclod.com': 'icloud.com', 'icloud.co': 'icloud.com',
      'live.co': 'live.com', 'aol.co': 'aol.com', 'sky.co': 'sky.com',
      'btinternet.co': 'btinternet.com', 'btintenet.com': 'btinternet.com'
    };

    var TLD_TYPOS = {
      con: 'com', cno: 'com', cmo: 'com', ocm: 'com', comm: 'com', cim: 'com',
      clm: 'com', vom: 'com', xom: 'com', som: 'com', cpm: 'com', dom: 'com',
      copm: 'com', cvom: 'com',
      nte: 'net', ent: 'net', ner: 'net', bet: 'net',
      ogr: 'org', orgg: 'org', rog: 'org', ork: 'org',
      cok: 'co.uk', couk: 'co.uk'
    };

    /* Returns a message to show the customer, or '' when the address looks
       deliverable. The suggestion is the whole point — "did you mean .com?"
       gets fixed, "invalid email" gets retyped identically. */
    function emailMessage(v) {
      var raw = String(v == null ? '' : v).trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(raw))
        return 'That email address does not look right.';
      var domain = raw.slice(raw.lastIndexOf('@') + 1).toLowerCase();
      if (domain.indexOf('..') !== -1 || domain.charAt(domain.length - 1) === '.')
        return 'That email address does not look right.';
      if (DOMAIN_TYPOS[domain])
        return 'Did you mean @' + DOMAIN_TYPOS[domain] + '? We send your order confirmation there.';
      var tld = domain.slice(domain.lastIndexOf('.') + 1);
      if (TLD_TYPOS[tld])
        return 'That ends .' + tld + ' — did you mean .' + TLD_TYPOS[tld] + '?';
      if (!/^[a-z]{2,}$/.test(tld))
        return 'That email address does not look right.';
      return '';
    }

    /* Exact match only, after stripping the filler words, so a real business
       called "Chase Recruitment Ltd" or "Tide Coffee" is never blocked. */
    var BANK_NAMES = (' barclays hsbc lloyds natwest nationwide santander halifax tsb'
      + ' monzo starling revolut metro chase tide mettle anna monese wise cashplus'
      + ' handelsbanken triodos smile rbs virgin yorkshire clydesdale danske ulster'
      + ' aib tesco sainsburys ').split(/\s+/);

    function normaliseBankish(v) {
      return String(v == null ? '' : v).toLowerCase()
        .replace(/[.,'’]/g, '')
        .replace(/\b(bank|banking|plc|ltd|limited|uk|group|the|business|account|current)\b/g, ' ')
        .replace(/\s+/g, ' ').trim();
    }

    function bankNameAsHolder(acctName, bankName) {
      var norm = normaliseBankish(acctName);
      if (!norm) return false;
      for (var i = 0; i < BANK_NAMES.length; i++)
        if (BANK_NAMES[i] && norm === BANK_NAMES[i]) return true;
      /* Catches the banks the list has never heard of: the same thing typed
         into both boxes is the same mistake. */
      return norm.length > 1 && norm === normaliseBankish(bankName);
    }

    /* ---- push back on bank details before they reach Kane ---------------
       The modulus check used to be a warning the customer could scroll past,
       so a mistyped account number still arrived as an order and still spent
       a credit search. Kane's words: push back BEFORE the customer can submit.

       Two cases, from his results:
       - The digits cannot be a real account for that sort code. Almost always
         a typo, and fixable on the spot.
       - The sort code is not in the VocaLink table at all. #1271 (SumUp) and
         #1297 (Kraken) were both declined, and his earlier sheet gave "Cannot
         validate Bank info" as a decline reason outright. E-money accounts
         like these often cannot take a Direct Debit.

       Push back, not a wall. Building-society roll numbers and a few genuine
       providers fail these checks, so pressing Next again with the SAME
       details goes through — the Worker still marks it on the order. Changing
       any digit re-arms the check. */
    var bankAckKey = '';

    function bankPushback() {
      var sort = sortEl ? sortEl.value.replace(/\D/g, '') : '';
      var acct = acctEl ? acctEl.value.replace(/\D/g, '') : '';
      var key = sort + '|' + acct;
      var base = (document.documentElement.getAttribute('data-bpd-application-endpoint') || '').trim();
      if (!base || sort.length !== 6 || acct.length !== 8 || key === bankAckKey) return Promise.resolve(false);

      var timedOut = false;
      var timer = new Promise(function (resolve) {
        window.setTimeout(function () { timedOut = true; resolve(null); }, 3000);
      });
      var look = fetch(base.replace(/\/$/, '') + '/bank?sort=' + sort + '&account=' + acct,
                       { mode: 'cors', credentials: 'omit' })
        .then(function (r) { return r && r.ok ? r.json() : null; });

      return Promise.race([look, timer])
        .then(function (d) {
          if (timedOut || !d) return false;             // never strand anyone on a slow network
          if (d.checked && d.pass === false) {
            bankAckKey = key;
            fail(acctEl, step6Err,
              'That account number does not match the sort code — please check both. ' +
              'If they are definitely right, press Next again.');
            return true;
          }
          if (!d.checked && /not in the modulus table/.test(String(d.reason || ''))) {
            bankAckKey = key;
            fail(sortEl, step6Err,
              'We cannot confirm this account can pay by Direct Debit. SumUp, Kraken and some ' +
              'e-money apps usually cannot. A UK bank or building society account works best — ' +
              'or press Next again to use this one.');
            return true;
          }
          return false;
        })
        .catch(function () { return false; });
    }

    function passesStep6() {
      clearErr(step6Err);
      [acctNmEl, sortEl, acctEl, bankEl].forEach(function (el) { if (el) el.classList.remove('is-invalid'); });
      var sort = sortEl ? sortEl.value.replace(/\D/g, '') : '';
      var acct = acctEl ? acctEl.value.replace(/\D/g, '') : '';
      /* The credit check runs against the account name, so an order without it
         cannot be processed — it is as required as the number itself. */
      if (!acctNmEl || acctNmEl.value.trim().length < 2)
        return fail(acctNmEl, step6Err, 'Please give the name on the bank account.');
      if (sort.length !== 6) return fail(sortEl, step6Err, 'A sort code is six digits, like 00-00-00.');
      if (acct.length !== 8) return fail(acctEl, step6Err, 'An account number is eight digits.');
      if (!bankEl || bankEl.value.trim().length < 2)
        return fail(bankEl, step6Err, 'Please tell us which bank the account is with.');
      /* #1322 put "Rented" here — an answer to the time-at-address question,
         in the bank box. Declined. */
      if (/^(rent(ed|ing)?|own(ed|er)?|home ?owner|mortgage[d]?|council|private|living with .*|n\/?a|none|no|yes)$/i.test(bankEl.value.trim()))
        return fail(bankEl, step6Err, 'That box is for the name of your bank \u2014 for example Barclays, Lloyds or Monzo.');
      /* Last, so they have already told us the bank and the message can name
         it back to them. */
      if (bankNameAsHolder(acctNmEl.value, bankEl.value))
        return fail(acctNmEl, step6Err,
          'That is your bank\u2019s name. We need the name the account is in \u2014 '
          + 'your own name, or your business name.');
      return true;
    }

    /* Both boxes, separately, and neither pre-ticked. Reported one at a time
       so the message names the thing they actually missed rather than telling
       them to "accept the terms" when what is unticked is the authority
       assertion. */
    function passesTerms() {
      /* Fail OPEN when the step is not rendered. The tick boxes sit behind a
         theme setting, so this file ships ahead of them being switched on —
         and a hard dependency here would block every order with an error the
         customer cannot clear, because there would be no box to tick. The
         Worker's REQUIRE_TERMS flag is the server-side half of the same
         guard. */
      if (!termsWrap) return true;
      clearErr(termsErr);
      [agreeTEl, agreeAEl].forEach(function (el) {
        if (el && el.parentNode) el.parentNode.classList.remove('is-invalid');
      });
      if (!agreeTEl || !agreeTEl.checked)
        return failCheck(agreeTEl, 'Please confirm you agree to the terms.');
      if (!agreeAEl || !agreeAEl.checked)
        return failCheck(agreeAEl, 'Please confirm you are authorised to sign for the business.');
      return true;
    }
    function failCheck(el, msg) {
      if (termsErr) { termsErr.textContent = msg; termsErr.hidden = false; }
      if (el && el.parentNode) el.parentNode.classList.add('is-invalid');
      if (el && el.focus) el.focus();
      return false;
    }

    /* What was agreed, to what, and when. Recorded rather than assumed: a tick
       box is only worth anything if you can still answer months later which
       wording the person actually saw. */
    function termsAccepted() {
      if (!termsWrap) return null;
      return {
        version: termsWrap.getAttribute('data-bpd-terms-version') || '',
        acceptedTerms: !!(agreeTEl && agreeTEl.checked),
        acceptedAuthority: !!(agreeAEl && agreeAEl.checked),
        acceptedAt: new Date().toISOString(),
        shownUrl: location.href.split('#')[0],
        documentsShown: Array.prototype.map.call(docLinks, function (a) {
          return (a.getAttribute('data-bpd-buy-doc') || '') + '|' + a.getAttribute('href');
        }),
        documentsOpened: docsOpened.slice()
      };
    }

    /* The sensitive half of the application. One POST, over HTTPS, to its own
       endpoint — never the marketing webhook, never localStorage, never the
       Shopify order. Fields are wiped from the DOM straight afterwards. */
    /* Swap the sheet for a confirmation. `ok` false means the endpoint didn't
       answer — we still say the order is in, because it is: the details are
       held locally and retried. What we never do is show someone a failure
       they cannot act on after they have handed over bank details. */
    function showDone(ok) {
      var steps = root.querySelectorAll('[data-bpd-buy-step]');
      for (var i = 0; i < steps.length; i++) steps[i].hidden = true;
      var done = root.querySelector('[data-bpd-buy-done]');
      if (done) done.hidden = false;
      var dots = root.querySelectorAll('[data-bpd-buy-dot]');
      for (var d = 0; d < dots.length; d++) dots[d].classList.add('is-on');
      var head = done && done.querySelector('.bpd-buy__q');
      if (head) { head.setAttribute('tabindex', '-1'); head.focus({ preventScroll: true }); }
      confetti(done || root);
    }

    function sendApplication() {
      var url = (document.documentElement.getAttribute('data-bpd-application-endpoint') || '').trim();
      if (!url) return Promise.resolve(false);
      var body = JSON.stringify({
        company: companyEl ? companyEl.value.trim() : '',
        companyNumber: companyNumber,
        businessType: businessType,
        mobileToken: mobileToken,
        name: nameEl ? nameEl.value.trim() : '',
        email: emailEl ? emailEl.value.trim() : '',
        mobile: mobile ? normaliseMobile(mobile.value) : '',
        dob: dob ? dob.value : '',
        address: addrEl ? addrEl.value.trim() : '',
        postcode: postEl ? postEl.value.trim().toUpperCase() : '',
        registeredOffice: regEl && businessType === 'limited' ? regEl.value.trim() : '',
        movedInOn: movedIn ? movedIn.value : '',
        salutation: titleEl ? titleEl.value : '',
        addressHistory: prevWrap && prevWrap.hidden ? [] : prevRowList().map(function (row) {
          return {
            address1: row.querySelector('[data-bpd-buy-prevaddr]').value.trim(),
            postcode: row.querySelector('[data-bpd-buy-prevpostcode]').value.trim().toUpperCase(),
            movedIn: row.querySelector('[data-bpd-buy-prevmovedin]').value,
          };
        }).filter(function (h) { return h.address1 && h.postcode && h.movedIn; }),
        sortCode: sortEl ? sortEl.value.replace(/\D/g, '') : '',
        accountNumber: acctEl ? acctEl.value.replace(/\D/g, '') : '',
        accountName: acctNmEl ? acctNmEl.value.trim() : '',
        bankName: bankEl ? bankEl.value.trim() : '',
        terms: termsAccepted(),
        pac: porting() && pac ? pac.value.trim().toUpperCase() : '',
        lines: lines, sim: chosenSim(),
        variantId: idInput ? Number(idInput.value) : null,
        quantity: lines,
        unitPrice: variants[0] && variants[0].price ? variants[0].price / 100 : 19.95,
        cashback: perLine * lines,
        partialId: readPartialId(),  // lets the endpoint retire the lead's draft
        eventId: purchaseEventId,
        leadEventId: leadEventId,
        utm: captureUtms(),
        fbc: fbIdentity().fbc,
        fbp: fbIdentity().fbp,
        pageUrl: location.href,
        submittedAt: new Date().toISOString()
      });
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body, mode: 'cors', credentials: 'omit'
      }).then(function (r) { return !!(r && r.ok); })
        .catch(function () { return false; })
        .then(function (ok) {
          [sortEl, acctEl, dob].forEach(function (el) { if (el) el.value = ''; });
          return ok;
        });
    }

    function open(seedLines) {
      lastFocus = document.activeElement;
      if (seedLines) lines = parseInt(seedLines, 10) || lines;
      /* The gate on the cashback panel already took a number — don't ask for
         it a second time. Same for anything the scratch or exit popup caught. */
      var known = knownLead();
      if (mobile && !mobile.value && known.mobile) mobile.value = known.mobile;
      if (nameEl && !nameEl.value && known.name)   nameEl.value = known.name;
      if (emailEl && !emailEl.value && known.email) emailEl.value = known.email;
      /* The gate on the cashback panel already took the number, so hide the
         field rather than showing it back to them. Anyone arriving from a CTA
         that has no gate still sees it. */
      if (mobile) {
        var mobileField = mobile.closest('.bpd-buy__field');
        if (mobileField) mobileField.hidden = looksLikeUkMobile(mobile.value);
      }
      render();
      root.hidden = false;
      /* Reading offsetHeight forces a synchronous reflow, which gives the
         transition its start state. rAF would be the obvious choice but it
         fires ZERO frames in a hidden document — see DESIGN.md §6. */
      void root.offsetHeight;
      if (document.hidden) root.classList.add('is-instant');
      root.classList.add('is-open');
      lockScroll();
      show(1);
      track('InitiateCheckout', { content_name: 'buy_flow', num_items: lines, currency: 'GBP' });
    }

    function close() {
      /* Closing the sheet without ordering is the commonest abandonment, and
         the one worth calling fastest. */
      if (!orderPlaced) {
        sendPartial('closed the popup', false);
        flushPixelLead('abandoned');
      }
      root.classList.remove('is-open');
      root.classList.remove('is-instant');
      unlockScroll();
      window.setTimeout(function () { root.hidden = true; }, 220);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    /* --- wiring --- */
    if (range) range.addEventListener('input', function () {
      lines = parseInt(range.value, 10) || 1; render();
    });
    var dec = root.querySelector('[data-bpd-buy-dec]');
    var inc = root.querySelector('[data-bpd-buy-inc]');
    if (dec) dec.addEventListener('click', function () { lines -= 1; render(); });
    if (inc) inc.addEventListener('click', function () { lines += 1; render(); });
    for (var s = 0; s < sims.length; s++) sims[s].addEventListener('change', render);
    for (var pr = 0; pr < ports.length; pr++) ports[pr].addEventListener('change', render);
    if (pac) pac.addEventListener('input', render);

    // 11-22-33 as they type; account number is digits only
    if (sortEl) sortEl.addEventListener('input', function () { maskDigits(sortEl, 6, 2, '-'); });
    if (acctEl) acctEl.addEventListener('input', function () { maskDigits(acctEl, 8, 0, ''); });

    if (mobile) {
      // clear the error as soon as they start correcting it
      mobile.addEventListener('input', function () {
        if (gateErr && !gateErr.hidden && looksLikeUkMobile(mobile.value)) {
          gateErr.hidden = true;
          mobile.classList.remove('is-invalid');
        }
        render();
      });
      mobile.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); if (passesGate()) show(4); }
      });
    }

    if (movedIn) {
      movedIn.max = thisMonth();
      movedIn.addEventListener('change', syncAddressHistory);
    }

    /* Enter inside a <form> fires its submit button natively, which is what
       let someone bypass all seven steps at once. Advance the step instead —
       the same thing the visible button does, guards and all. */
    form.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var t = e.target;
      if (!t || t.tagName === 'TEXTAREA' || t.tagName === 'BUTTON') return;
      var step = t.closest ? t.closest('[data-bpd-buy-step]') : null;
      if (!step) return;
      var btn = step.querySelector('[data-bpd-buy-next], [data-bpd-buy-submit]');
      if (!btn) return;
      e.preventDefault();
      btn.click();
    });

    var nexts = root.querySelectorAll('[data-bpd-buy-next]');
    for (var n0 = 0; n0 < nexts.length; n0++) {
      nexts[n0].addEventListener('click', function () {
        var to = parseInt(this.getAttribute('data-bpd-buy-next'), 10);
        if (this.hasAttribute('data-bpd-buy-gate')   && !passesGate())  return;
        /* Verification sits between step 3 and step 4. Only intercept when a
           code can actually be sent — if Twilio is unconfigured or the send
           fails, carry on to step 4 rather than stranding the customer behind
           a code that is never going to arrive. */
        /* Before the code is sent: a text costs money, and there is no point
           verifying someone we are about to send back to fix their name. */
        if (this.hasAttribute('data-bpd-buy-gate') && !directorChecked) {
          var btn = this;
          directorCheck().then(function (blocked) {
            if (blocked) return;
            directorChecked = true;
            btn.click();                      // straight back through, now cleared
          });
          return;
        }
        if (this.hasAttribute('data-bpd-buy-gate') && otpPanel &&
            normaliseMobile(mobile.value) !== verifiedNumber) {
          otpReturnStep = to;
          if (otpToEl) otpToEl.textContent = 'We have texted a 6-digit code to ' + mobile.value.trim() + '.';
          otpPanelShow(true);
          otpSend().then(function (sent) { if (!sent) { otpPanelShow(false); show(to); } });
          return;
        }
        if (this.hasAttribute('data-bpd-buy-check4')) {
          if (!passesStep4()) return;
          /* The register lookup needs the date of birth this step just
             collected, so it can only run here. Advancing waits on it, and
             carries on unchanged if there is nothing to offer. */
          var goTo = to;
          wcoNextStep = to;
          wcoOffer().then(function (shown) { if (!shown) show(goTo); });
          return;
        }
        if (this.hasAttribute('data-bpd-buy-check6')) {
          if (!passesStep6()) return;
          var go6 = to;
          bankPushback().then(function (pushedBack) { if (!pushedBack) show(go6); });
          return;
        }
        show(to);
      });
    }
    var backs = root.querySelectorAll('[data-bpd-buy-back]');
    for (var b0 = 0; b0 < backs.length; b0++) {
      backs[b0].addEventListener('click', function () {
        show(parseInt(this.getAttribute('data-bpd-buy-back'), 10));
      });
    }
    var closers = root.querySelectorAll('[data-bpd-buy-close]');
    for (var c0 = 0; c0 < closers.length; c0++) closers[c0].addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) close();
    });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) root.classList.remove('is-instant');
    });

    /* Add to cart without a page load, then straight to checkout. Anything
       going wrong falls through to a normal form POST rather than trapping
       someone who has already decided to buy. */
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();

      /* Every check lived on the Next buttons, and this one is type="submit"
         inside a <form novalidate> — so Enter in any input placed the order
         and skipped all of them. That is how an order arrived with no bank
         details and a date of birth in 2027. Re-run the lot here: whichever
         step fails, go back to it so the person can see what is wrong. */
      if (!passesGate())  { show(3); return; }
      if (!passesStep4()) { show(4); return; }
      if (!passesStep6()) { show(6); return; }
      /* Last, because it is the only check whose failure keeps them on this
         step — everything else sends them backwards. */
      if (!passesTerms()) return;

      if (submit) { submit.disabled = true; if (submitLbl) submitLbl.textContent = 'Placing your order…'; }

      /* No checkout. Nothing is charged today — Vodafone bills the airtime —
         so sending someone to a payment page to enter a card for a charge we
         never take is friction for nothing.

         One POST places the order. The endpoint holds the Admin API token
         server-side (it CANNOT live here: theme JS is public) and creates the
         Shopify order, so admin, emails and reporting all still happen. */
      orderPlaced = true;   // stop any further partial/abandon capture
      purchaseEventId = newEventId();
      sendApplication().then(function (ok) {
        /* The draft is retagged server-side from the partialId in the payload,
           so sales stops seeing them as a lead to ring. */
        if (ok) writePartialId(null);
        /* An order is a lead too. Fire the held one first so the funnel reads
           Lead -> Purchase for the same person, rather than the Lead going
           missing entirely for everyone who actually converts. */
        flushPixelLead('ordered');
        track('Purchase', {
          content_name: 'buy_flow', num_items: lines,
          value: +((variants[0] && variants[0].price ? variants[0].price / 100 : 19.95) * lines).toFixed(2),
          currency: 'GBP',
        }, purchaseEventId);
        showDone(ok);
      });
    });

    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-bpd-buy-open]') : null;
      if (!t) return;
      e.preventDefault();
      /* The mobile drawer has its own CTA that opens this popup. Close the
         drawer FIRST: both take the scroll lock, so leaving it open would
         hold a second lock that nothing ever releases and the page would
         stay frozen with body position:fixed after the popup closed. */
      var openDrawer = document.querySelector('[data-bpd-drawer].is-open');
      if (openDrawer) {
        var dc = openDrawer.querySelector('[data-bpd-drawer-close]');
        if (dc) dc.click();
      }
      open(t.getAttribute('data-lines'));
    });

    /* Closing the tab or switching away mid-flow is abandonment too, and on
       mobile it is the usual one — people do not close the sheet, they leave.
       pagehide fires on iOS where unload does not; visibilitychange covers
       backgrounding the browser. Both go by beacon, which survives teardown. */
    window.addEventListener('pagehide', function () {
      if (!orderPlaced && !root.hidden) {
        sendPartial('left the page', true);
        flushPixelLead('abandoned');
      }
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden' && !orderPlaced && !root.hidden) {
        sendPartial('switched away', true);
        flushPixelLead('abandoned');
      }
    });

    render();
  }

  /* ---------- Ticker: only animate while it's on screen ---------- */
  function initTicker() {
    var tickers = document.querySelectorAll('.bpd-ticker');
    if (!tickers.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        // An infinite animation running off-screen keeps the compositor busy
        // for no visible benefit.
        entries[i].target.classList.toggle('is-paused', !entries[i].isIntersecting);
      }
    }, { rootMargin: '120px 0px' });
    for (var i = 0; i < tickers.length; i++) io.observe(tickers[i]);
  }

  /* ---------- Welcome-offer countdown ---------- */
  function initWelcome(root) {
    var iso = (root.getAttribute('data-deadline') || '').trim();
    var mode = root.getAttribute('data-expired-mode') || 'hide';
    var clock = root.querySelector('[data-bpd-welcome-clock]');

    /* No deadline set = no clock. The bar still shows the offer, because an
       offer without an end date is honest; a timer without one is not. */
    if (!iso) {
      if (clock) clock.hidden = true;
      root.hidden = false;
      return;
    }

    var end = Date.parse(iso);
    if (isNaN(end)) {
      if (clock) clock.hidden = true;
      root.hidden = false;
      return;
    }

    var els = {
      d: root.querySelector('[data-cd-d]'), h: root.querySelector('[data-cd-h]'),
      m: root.querySelector('[data-cd-m]'), s: root.querySelector('[data-cd-s]'),
    };
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };

    function expire() {
      if (mode === 'hide') { root.hidden = true; return; }
      if (clock) clock.hidden = true;
      root.hidden = false;
    }

    function tick() {
      var left = end - Date.now();
      if (left <= 0) { expire(); return false; }
      var s = Math.floor(left / 1000);
      if (els.d) els.d.textContent = pad(Math.floor(s / 86400));
      if (els.h) els.h.textContent = pad(Math.floor(s / 3600) % 24);
      if (els.m) els.m.textContent = pad(Math.floor(s / 60) % 60);
      if (els.s) els.s.textContent = pad(s % 60);
      return true;
    }

    // Write the real value synchronously before revealing, so the bar never
    // flashes 00:00:00:00 on first paint.
    if (!tick()) return;
    root.hidden = false;
    var id = window.setInterval(function () { if (!tick()) window.clearInterval(id); }, 1000);
  }

  /* ---------- Sticky mobile CTA ---------- */
  function initStickyCta(el) {
    var shown = false;
    var trigger = Math.round(window.innerHeight * 0.7);

    /* The bar must not sit on top of anything tappable — it used to cover the
       "Your mobile number" field, which is the whole lead capture.

       ⚠️ PERFORMANCE. The first version of this check ran querySelectorAll AND
       a getBoundingClientRect per element on EVERY scroll event, which forces
       a synchronous layout dozens of times a second and made scrolling stutter
       on a phone. Three things fix that, and all three matter:
         · the node list is queried ONCE, not per scroll
         · the work is rAF-throttled, so layout is read at most once a frame
         · above the trigger point we return before touching layout at all

       Geometry rather than IntersectionObserver because these sections use
       `content-visibility: auto`: off-screen elements never lay out, so the
       observer's callbacks do not match reality and an earlier attempt left
       the bar hidden permanently. */
    /* ⚠️ TEXT INPUTS ONLY. Keep this list as short as it possibly can be.

       The first version protected buttons too — every `[data-bpd-buy-open]`,
       both hero and cashback CTAs, eight elements in all. The bar then hid and
       reappeared every time any of them crossed the bottom strip: NINE slides
       in a single scroll of this page, each a 0.28s animation. That is what
       "laggy and buggy" was. It was never frame rate; it was the bar itself
       moving under the reader's thumb.

       A button does not need protecting — this bar IS a button, so covering
       another one costs nothing. The only thing that genuinely must not be
       obscured is a field you have to see while typing into it. */
    var PROTECT = '[data-bpd-cb-mobile], [data-bpd-lead] input';
    var nodes = document.querySelectorAll(PROTECT);

    function coversSomething() {
      /* Asymmetric margins: once hidden it takes a bigger clearance to come
         back than it took to go away. Without that the bar flutters whenever a
         field sits exactly on the boundary. */
      var margin = shown ? 8 : 56;
      var band = window.innerHeight - (el.offsetHeight || 74) - margin;
      for (var i = 0; i < nodes.length; i++) {
        var r = nodes[i].getBoundingClientRect();
        if (!r.width || !r.height) continue;
        if (r.bottom > band && r.top < window.innerHeight) return true;
      }
      return false;
    }

    function evaluate() {
      // cheap test first — no layout read at all near the top of the page
      var should = window.scrollY > trigger && !coversSomething();
      if (should === shown) return;
      shown = should;
      el.classList.toggle('is-on', shown);
    }

    var queued = false;
    function onScroll() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () { queued = false; evaluate(); });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      trigger = Math.round(window.innerHeight * 0.7);
      nodes = document.querySelectorAll(PROTECT);   // layout changed, re-query
      onScroll();
    });
    evaluate();
  }



  /* ---------- Exit intent ---------- */
  function initExit(root) {
    var key = root.dataset.storageKey || 'bpd_exit_v1';
    var minMs = (parseFloat(root.dataset.minSeconds) || 0) * 1000;
    var form = root.querySelector('[data-bpd-exit-form]');
    var done = root.querySelector('[data-bpd-exit-done]');

    var seen = false, claimedScratch = false;
    try {
      seen = localStorage.getItem(key) === '1';
      // Two offer modals in one visit reads as desperate — if they already
      // took the scratch offer, this never fires.
      claimedScratch = localStorage.getItem('bpd_scratch_v1_claimed') === '1';
    } catch (e) {}
    if (seen || claimedScratch) return;

    var armedAt = Date.now() + minMs;
    var open = false;

    function show() {
      if (open) return;
      if (Date.now() < armedAt) return;
      /* Never stack on another modal. This is the bug that made the popup
         feel unhinged: lockScroll() pins the body with position:fixed and
         top:-Ypx, which snaps window.scrollY to 0 instantly. The flick
         detector below read that as a violent upward swipe, so simply
         TAPPING the sticky "Continue to checkout" opened the buy flow and
         this popup at the same time, stacked. */
      if (scrollLocks > 0) return;
      open = true;
      root.hidden = false;
      root.offsetHeight;
      root.classList.add('is-open');
      lockScroll();
      try { localStorage.setItem(key, '1'); } catch (e) {}
      var f = root.querySelector('input, button');
      if (f) f.focus();
      detach();
    }

    function close() {
      root.classList.remove('is-open');
      unlockScroll();
      window.setTimeout(function () {
        if (!root.classList.contains('is-open')) root.hidden = true;
      }, 260);
    }

    // Desktop: a real mouse-out toward the browser chrome
    function onLeave(e) {
      if (e.clientY <= 2 && !e.relatedTarget) show();
    }

    // Mobile: no exit-intent signal exists, so use a fast upward flick after
    // the visitor has actually scrolled into the page. Never a bare timer.
    var lastY = window.scrollY, lastT = Date.now(), deepest = 0;
    function onScroll() {
      /* A lock is held, so this jump is ours, not the visitor's. Resync the
         baseline and measure nothing — otherwise opening any modal reads as
         a full-speed scroll to the top. */
      if (scrollLocks > 0) { lastY = window.scrollY; lastT = Date.now(); return; }
      var y = window.scrollY, t = Date.now();
      deepest = Math.max(deepest, y);
      var dy = y - lastY, dt = t - lastT;
      /* Deliberately grudging: they have to have read a long way down AND
         thrown the page back to the top. Anything looser fires on ordinary
         browsing, which is what made this feel pushy. */
      if (dt > 0 && dy < 0 && deepest > 900 && y < 260 && (Math.abs(dy) / dt) > 2.2) show();
      lastY = y; lastT = t;
    }

    // Back-button: push one state so the first back press is catchable
    function armHistory() {
      try {
        history.pushState({ bpdExit: 1 }, '');
        window.addEventListener('popstate', onPop);
      } catch (e) {}
    }
    function onPop() {
      /* Closing a modal can pop our own pushed state. Showing the exit
         popup then punishes someone for dismissing a different one. */
      if (scrollLocks > 0) return;
      show();
    }

    function detach() {
      document.removeEventListener('mouseout', onLeave);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('popstate', onPop);
    }

    document.addEventListener('mouseout', onLeave);
    window.addEventListener('scroll', onScroll, { passive: true });
    if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) {
      window.setTimeout(armHistory, minMs);
    }

    var closers = root.querySelectorAll('[data-bpd-exit-close]');
    for (var i = 0; i < closers.length; i++) closers[i].addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    initLeadForm(form, {
      source: 'exit_intent',
      onDone: function (lead) {
        if (form) form.hidden = true;
        if (done) done.hidden = false;
        root.dispatchEvent(new CustomEvent('bpd:exit-lead', { bubbles: true, detail: lead }));
        window.setTimeout(close, 1800);
      },
    });

    root.bpdExit = { show: show, close: close };
  }

  /* ---------- eSIM compatibility check ---------- */
  function initEsimCheck(root) {
    var verdictEl = root.querySelector('[data-bpd-esim-verdict]');
    var deviceEl  = root.querySelector('[data-bpd-esim-device]');
    var detailEl  = root.querySelector('[data-bpd-esim-detail]');
    var resultEl  = root.querySelector('[data-bpd-esim-result]');
    var howEl     = root.querySelector('[data-bpd-esim-how]');
    if (!verdictEl) return;

    /* A user agent cannot tell us the exact handset on modern iOS or Android,
       so this deliberately reports a confidence level, never a guarantee.
       Every branch still offers the physical SIM as the certain path. */
    function detect() {
      var ua = navigator.userAgent || '';
      var isIpad = /iPad/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
      var isIphone = /iPhone/.test(ua);
      var isAndroid = /Android/i.test(ua);
      var isDesktop = !isIphone && !isAndroid && !isIpad;

      if (isDesktop) {
        return {
          level: 'desktop',
          device: 'You’re on a computer',
          verdict: 'Check on the phone itself',
          detail: 'Open this page on the handset you want to connect and we’ll check it. Or just look for “Add eSIM” in its mobile settings — if it’s there, you’re fine.',
          how: true,
        };
      }

      if (isIphone) {
        // iOS stopped reporting minor versions and never reports the model,
        // so key off the OS version we can see. eSIM landed with iPhone XS,
        // which cannot run anything below iOS 12.
        var m = /OS (\d+)_/.exec(ua);
        var major = m ? parseInt(m[1], 10) : 0;
        if (major >= 13) {
          return {
            level: 'yes',
            device: 'iPhone · iOS ' + major,
            verdict: 'Almost certainly yes',
            detail: 'Any iPhone running iOS ' + major + ' is an iPhone XS or newer, and every one of those takes an eSIM. The only exception is an iPhone bought in mainland China.',
            how: true,
          };
        }
        return {
          level: 'maybe',
          device: 'iPhone' + (major ? ' · iOS ' + major : ''),
          verdict: 'Worth a quick check',
          detail: 'We can’t tell which iPhone this is. eSIM works on iPhone XS and newer. Have a look in Settings, or take a physical SIM and skip the question.',
          how: true,
        };
      }

      if (isAndroid) {
        return {
          level: 'maybe',
          device: 'Android',
          verdict: 'Very likely — have a quick look',
          detail: 'Android doesn’t tell websites the model, so we won’t pretend to know. Most Pixels from the 3 onward and most Samsung Galaxy S20 and newer handsets take eSIM. Thirty seconds in Settings will confirm it.',
          how: true,
        };
      }

      return {
        level: 'maybe',
        device: 'Tablet or other device',
        verdict: 'Check the handset',
        detail: 'Open this page on the phone you want to connect, or choose a physical SIM at checkout.',
        how: true,
      };
    }

    function apply() {
      var r = detect();
      if (deviceEl)  deviceEl.textContent = r.device;
      if (verdictEl) verdictEl.textContent = r.verdict;
      if (detailEl)  detailEl.textContent = r.detail;
      if (resultEl) {
        resultEl.classList.toggle('is-yes', r.level === 'yes');
        resultEl.classList.toggle('is-maybe', r.level === 'maybe');
      }
      if (howEl) howEl.hidden = !r.how;
      return r;
    }

    apply();
    root.bpdEsim = { recheck: apply, detect: detect };
  }

  /* ---------- Cashback builder ---------- */
  /* WebKit has no ::-moz-range-progress equivalent, so the filled part of the
     track is a background sized by this var. Keep it in step with the value. */
  function paintRange(el) {
    if (!el) return;
    var lo = parseFloat(el.min) || 0;
    var hi = parseFloat(el.max);
    var v  = parseFloat(el.value);
    if (!isFinite(hi) || hi === lo || !isFinite(v)) return;
    el.style.setProperty('--range-pct', (((v - lo) / (hi - lo)) * 100) + '%');
  }

  function initCashback(root) {
    var range = root.querySelector('[data-bpd-cb-range]');
    if (!range) return;

    var price   = parseFloat(root.dataset.price || '19.95');
    var perLine = parseFloat(root.dataset.perLine || '50');
    var cap     = parseFloat(root.dataset.cap || '0');   // 0 = uncapped
    var months  = parseInt(root.dataset.termMonths, 10) || 12;
    var max     = parseInt(root.dataset.max, 10) || 10;

    var fill    = root.querySelector('[data-bpd-cb-fill]');
    var notches = root.querySelector('[data-bpd-cb-notches]');
    var stage   = root.querySelector('[data-bpd-cb-stage]');
    var cta     = root.querySelector('[data-bpd-cb-cta]');
    var ctaLbl  = root.querySelector('[data-bpd-cb-ctalabel]');
    var ctaTpl  = ctaLbl ? ctaLbl.textContent.trim() : '';

    /* With no cap, cashback climbs forever, so the meter can't be a fill-to-
       target bar. Notches mark line counts instead and the bar shows progress
       across the slider's own range. */
    var capLines = cap > 0 ? Math.max(1, Math.ceil(cap / perLine)) : Infinity;
    var stops = [];
    for (var st = 1; st <= max; st++) {
      if (st <= 3 || st === 5 || st === 10 || st === max) stops.push(st);
      if (stops.length >= 5) break;
    }
    /* Milestones are buttons, not decoration — tapping one jumps the slider
       there. On a phone that beats dragging a thumb to an exact stop. */
    if (notches) {
      notches.innerHTML = '';
      for (var i = 0; i < stops.length; i++) {
        var at = stops[i];
        var amt = cap > 0 ? Math.min(cap, perLine * at) : perLine * at;
        var n = document.createElement('button');
        n.type = 'button';
        n.className = 'bpd-cb__notch';
        n.setAttribute('data-at', String(at));
        n.setAttribute('aria-label', 'Set ' + at + (at === 1 ? ' line' : ' lines') + ' — £' + amt + ' cashback');
        n.innerHTML = '<b>£' + amt + '</b><span>' + at + (at === 1 ? ' line' : ' lines') + '</span>';
        notches.appendChild(n);
      }
      notches.addEventListener('click', function (e) {
        var hit = e.target.closest ? e.target.closest('.bpd-cb__notch') : null;
        if (!hit) return;
        range.value = hit.getAttribute('data-at');
        render(true);
        confetti(hit);
      });
    }

    // Pooled cards, same as the unlock builder — rebuilding mid-drag flickers
    var MAX_CARDS = 6;
    var vfTpl = root.querySelector('[data-bpd-cb-vf]');
    var VF = vfTpl ? vfTpl.innerHTML : '';
    /* Same punch-out the hero card uses, so the two read as the same
       product rather than two different red rectangles. */
    var SIMCHIP = '<svg class="bpd-simchip" viewBox="0 0 132 104" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"> <defs> <linearGradient id="bpd-chipgold" x1="0" y1="0" x2="1" y2="1"> <stop offset="0" stop-color="#FFF0C4"/> <stop offset=".45" stop-color="#E9BC55"/> <stop offset="1" stop-color="#BC8A28"/> </linearGradient> </defs> <!-- scored tear-out outline: the shape you push the SIM out along --> <path d="M6 12a10 10 0 0 1 10-10h84l26 24v66a10 10 0 0 1-10 10H16a10 10 0 0 1-10-10V12Z" stroke="#fff" stroke-width="5" stroke-linejoin="round" opacity=".95"/> <!-- the chip, chamfered top-right to match the outline --> <path d="M20 22a6 6 0 0 1 6-6h68l18 17v49a6 6 0 0 1-6 6H26a6 6 0 0 1-6-6V22Z" fill="url(#bpd-chipgold)"/> <!-- contact pads: centre rail with two columns either side --> <g stroke="#8A6218" stroke-opacity=".55" stroke-width="2.4" stroke-linecap="round"> <path d="M20 52h92"/> <path d="M56 16v72"/> <path d="M20 34h36M76 34h36"/> <path d="M20 70h36M76 70h36"/> </g> </svg>';
    var cards = [], more = null;
    if (stage) {
      for (var c = 0; c < MAX_CARDS; c++) {
        var card = document.createElement('span');
        card.className = 'bpd-unlock__card';
        card.innerHTML = '<i>' + SIMCHIP + '</i>' + VF + '<u>Unlimited</u>';
        stage.appendChild(card);
        cards.push(card);
      }
      more = document.createElement('span');
      more.className = 'bpd-unlock__more';
      more.hidden = true;
      stage.appendChild(more);
    }

    var lastCash = -1;

    function render(fromUser) {
      var n = Math.min(max, Math.max(1, parseInt(range.value, 10) || 1));
      paintRange(range);
      var cash = cap > 0 ? Math.min(cap, perLine * n) : perLine * n;

      var monthly = price * n;

      // Cards
      var drawn = Math.min(n, MAX_CARDS);
      for (var i = 0; i < cards.length; i++) {
        var on = i < drawn;
        cards[i].style.opacity = on ? '1' : '0';
        var spread = drawn === 1 ? 0 : (i - (drawn - 1) / 2);
        cards[i].style.transform =
          'translateX(' + (spread * 34) + 'px) translateY(' + (Math.abs(spread) * 6) + 'px) rotate(' + (spread * 7) + 'deg)';
        cards[i].style.zIndex = String(10 - Math.round(Math.abs(spread)));
      }
      if (more) { more.hidden = n <= MAX_CARDS; more.textContent = '+' + (n - MAX_CARDS); }

      // Meter
      if (fill) fill.style.width = Math.min(100, (n / max) * 100) + '%';
      setTxt('[data-bpd-cb-metervalue]', money(cash));
      if (notches) {
        var ns = notches.querySelectorAll('.bpd-cb__notch');
        for (var k = 0; k < ns.length; k++) {
          var at = parseInt(ns[k].getAttribute('data-at'), 10) || 1;
          ns[k].classList.toggle('is-hit', n >= at);
          ns[k].classList.toggle('is-max', n >= at && at === stops[stops.length - 1]);
        }
      }

      var nextCash = cap > 0 ? Math.min(cap, perLine * (n + 1)) : perLine * (n + 1);
      setTxt('[data-bpd-cb-lineslabel]', n + (n === 1 ? ' line' : ' lines') +
        (n < max && nextCash > cash ? ' — one more takes you to ' + money(nextCash) : ''));

      setTxt('[data-bpd-cb-cashback]', money(cash));
      setTxt('[data-bpd-cb-summary]', n + (n === 1 ? ' line' : ' lines') + ' × ' + money(price));
      setTxt('[data-bpd-cb-monthly]', money(monthly) + '/mo');
      setTxt('[data-bpd-cb-perline]', money(perLine));

      if (ctaLbl && ctaTpl) {
        // money() not String() — at £150/line this passes £1,000 quickly and
        // "£1500 back" reads like a typo.
        ctaLbl.textContent = cash > 0
          ? ctaTpl.replace('£{cash}', money(cash)).replace('{cash}', money(cash).replace('£', ''))
          : 'Get ' + n + (n === 1 ? ' line' : ' lines');
      }
      if (cta) {
        var base = cta.getAttribute('data-base') || cta.getAttribute('href');
        cta.setAttribute('data-base', base);
        cta.setAttribute('href', base + (base.indexOf('?') > -1 ? '&' : '?') +
          'lines=' + n);
        // the modal reads this so the visitor never answers "how many" twice
        cta.setAttribute('data-lines', String(n));
      }

      // Celebrate a genuinely new cashback step, never the initial paint
      if (fromUser && cash > lastCash && lastCash !== -1 && cash > 0) {
        confetti(root.querySelector('.bpd-cb__left'), n >= 3 ? 34 : 20);
      }
      lastCash = cash;
    }

    function setTxt(sel, v) {
      var els = root.querySelectorAll(sel);
      for (var i = 0; i < els.length; i++) els[i].textContent = v;
    }

    /* Mobile gate — the CTA is inert until a valid UK mobile is in. This is
       the only door into the order flow, so the number is captured before any
       of the work happens and an abandon still leaves a contact. */
    var gateInput = root.querySelector('[data-bpd-cb-mobile]');
    var gateErr   = root.querySelector('[data-bpd-cb-gateerr]');
    var gateOpen  = false;

    function gateValid() { return !!(gateInput && looksLikeUkMobile(gateInput.value)); }

    function syncGate() {
      var ok = gateValid();
      if (cta) {
        cta.classList.toggle('bpd-cb__cta-locked', !ok);
        cta.setAttribute('aria-disabled', ok ? 'false' : 'true');
      }
      if (ok && gateErr) gateErr.hidden = true;
      if (ok && gateInput) gateInput.classList.remove('is-invalid');

      // capture once, the moment it becomes valid
      if (ok && !gateOpen) {
        gateOpen = true;
        var n = Math.min(max, Math.max(1, parseInt(range.value, 10) || 1));
        var lead = rememberLead({
          mobile: normaliseMobile(gateInput.value),
          callConsent: false,          // no tickbox — screen against TPS/CTPS
          consentAt: new Date().toISOString(),
          source: 'cashback_gate',
          lines: n,
          cashback: cap > 0 ? Math.min(cap, perLine * n) : perLine * n,
          monthly: +(price * n).toFixed(2),
        });
        track('Lead', { content_name: 'cashback_gate', value: lead.cashback, currency: 'GBP', num_items: n });
        document.dispatchEvent(new CustomEvent('bpd:lead', { detail: lead }));
        sendLead(lead);
      }
    }

    if (gateInput) {
      gateInput.addEventListener('input', syncGate);
      gateInput.addEventListener('blur', function () {
        if (gateInput.value.trim() && !gateValid()) {
          if (gateErr) gateErr.hidden = false;
          gateInput.classList.add('is-invalid');
        }
      });
    }

    /* Capture phase, so a locked CTA never reaches the buy flow's own
       document-level open handler. */
    if (cta) cta.addEventListener('click', function (e) {
      if (gateValid()) return;
      e.preventDefault();
      e.stopPropagation();
      if (gateErr) gateErr.hidden = false;
      if (gateInput) { gateInput.classList.add('is-invalid'); gateInput.focus(); }
    }, true);

    syncGate();

    range.addEventListener('input', function () { render(true); });
    if (cta) {
      cta.addEventListener('click', function () {
        var n = Math.min(max, Math.max(1, parseInt(range.value, 10) || 1));
        track('AddToCart', {
          content_name: 'Business Unlimited',
          content_type: 'product',
          num_items: n,
          value: price * n,
          currency: 'GBP',
        });
      });
    }
    render(false);   // true values written synchronously
  }

  /* ---------- Scratch card takeover ---------- */
  function initScratch(root) {
    var panel = root.querySelector('[data-bpd-scratch-panel]');
    var canvas = root.querySelector('[data-bpd-scratch-foil]');
    var claim = root.querySelector('[data-bpd-scratch-claim]');
    var done = root.querySelector('[data-bpd-scratch-done]');
    var form = root.querySelector('[data-bpd-scratch-form]');
    var codeEl = root.querySelector('[data-bpd-scratch-code]');
    var dataEl = root.querySelector('[data-bpd-scratch-prizes]');
    if (!panel || !canvas || !dataEl) return;

    var key = root.dataset.storageKey || 'bpd_scratch_v1';
    var prizes = [];
    try { prizes = JSON.parse(dataEl.textContent) || []; } catch (e) { prizes = []; }
    if (!prizes.length) return;

    /* Pick the prize UP FRONT — scratching reveals a decided result, it does
       not decide one. Same as a real card, and it means a slow reveal or a
       reload mid-scratch can't reroll a better prize. */
    function draw() {
      var total = 0, i;
      for (i = 0; i < prizes.length; i++) total += Number(prizes[i].weight) || 1;
      var r = Math.random() * total;
      for (i = 0; i < prizes.length; i++) {
        r -= Number(prizes[i].weight) || 1;
        if (r <= 0) return prizes[i];
      }
      return prizes[prizes.length - 1];
    }

    var prize = draw();
    setText('[data-bpd-scratch-value]', prize.value);
    setText('[data-bpd-scratch-label]', prize.label);
    setText('[data-bpd-scratch-sub]', prize.sub);
    if (codeEl) codeEl.textContent = prize.code;

    function setText(sel, v) {
      var el = root.querySelector(sel);
      if (el) el.textContent = v == null ? '' : String(v);
    }

    /* ---- foil ---- */
    var FOIL_FONT = '"Inter Tight", "Inter", system-ui, sans-serif';
    var SCRATCH_PROMPT = root.getAttribute('data-prompt') || 'SCRATCH HERE';
    var ctx = canvas.getContext('2d');
    var revealed = false;
    var painting = false;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);

    /* The foil texture is ~120KB over the wire and this card is a takeover most
       visitors never open, so fetching it on page load spent the mobile budget
       on decoration. It is loaded on FIRST OPEN instead; until it lands the
       procedural gold in paintFoil() stands in, which is why this can be lazy
       without the card ever looking unfinished. */
    var foilImg = null;
    var foilRequested = false;
    function loadFoil() {
      if (foilRequested) return;
      foilRequested = true;
      var foilSrc = root.getAttribute('data-foil');
      if (!foilSrc) return;
      foilImg = new Image();
      foilImg.decoding = 'async';
      foilImg.onload = function () { if (!revealed) paintFoil(); };
      foilImg.onerror = function () { foilImg = null; if (!revealed) paintFoil(); };
      foilImg.src = foilSrc;
    }

    function paintFoil() {
      var r = panel.getBoundingClientRect();
      if (!r.width) return;
      canvas.width = Math.round(r.width * dpr);
      canvas.height = Math.round(r.height * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.globalCompositeOperation = 'source-over';

      if (foilImg && foilImg.complete && foilImg.naturalWidth) {
        // cover-fit the real foil texture
        var ir = foilImg.naturalWidth / foilImg.naturalHeight;
        var pr = r.width / r.height;
        var dw, dh;
        if (ir > pr) { dh = r.height; dw = dh * ir; }
        else { dw = r.width; dh = dw / ir; }
        ctx.drawImage(foilImg, (r.width - dw) / 2, (r.height - dh) / 2, dw, dh);
      } else {
        // Procedural gold, used until the texture lands or if it fails
        var g = ctx.createLinearGradient(0, 0, r.width, r.height);
        g.addColorStop(0, '#B98A34');
        g.addColorStop(0.3, '#E8C97A');
        g.addColorStop(0.52, '#F3E0A8');
        g.addColorStop(0.74, '#D9B45E');
        g.addColorStop(1, '#A8792A');
        ctx.fillStyle = g;
        ctx.fillRect(0, 0, r.width, r.height);
        ctx.strokeStyle = 'rgba(255,255,255,.14)';
        ctx.lineWidth = 1;
        for (var x = -r.height; x < r.width; x += 6) {
          ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x + r.height, r.height); ctx.stroke();
        }
      }

      // "WIN" ghosted into the foil, then the prompt over it — the reward is
      // implied before the scratch, which is what makes people scratch.
      ctx.save();
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = 'rgba(255,255,255,.20)';
      ctx.font = '800 ' + Math.round(r.height * 0.62) + 'px ' + FOIL_FONT;
      ctx.fillText('WIN', r.width / 2, r.height / 2);
      ctx.fillStyle = 'rgba(255,255,255,.92)';
      ctx.font = '800 ' + Math.round(r.height * 0.16) + 'px ' + FOIL_FONT;
      ctx.letterSpacing = '2px';
      ctx.fillText(SCRATCH_PROMPT, r.width / 2, r.height / 2);
      ctx.restore();

      ctx.globalCompositeOperation = 'destination-out';
    }

    function pointAt(e) {
      var r = canvas.getBoundingClientRect();
      return { x: e.clientX - r.left, y: e.clientY - r.top };
    }

    var BRUSH = 46;          // was 26 — a thumb-sized brush, not a pencil
    var last = null;

    function scratchAt(p) {
      // A dot per pointermove leaves gaps on a fast drag, which is what made
      // this feel like scrubbing. Draw a thick line from the previous point.
      if (last) {
        ctx.lineWidth = BRUSH * 2;
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.beginPath();
        ctx.moveTo(last.x, last.y);
        ctx.lineTo(p.x, p.y);
        ctx.stroke();
      }
      ctx.beginPath();
      ctx.arc(p.x, p.y, BRUSH, 0, Math.PI * 2);
      ctx.fill();
      last = p;
    }

    /* Sample the alpha channel on a coarse grid — cheap enough to run on
       pointerup rather than every move. */
    function clearedFraction() {
      var w = canvas.width, h = canvas.height;
      if (!w || !h) return 0;
      var img;
      try { img = ctx.getImageData(0, 0, w, h).data; } catch (e) { return 0; }
      var clear = 0, total = 0;
      var step = 4 * 40;                      // every 40th pixel — this runs mid-drag
      for (var i = 3; i < img.length; i += step) {
        total++;
        if (img[i] < 40) clear++;
      }
      return total ? clear / total : 0;
    }

    function reveal() {
      if (revealed) return;
      revealed = true;
      panel.classList.add('is-revealed');
      if (claim) claim.hidden = false;
      var hint = root.querySelector('[data-bpd-scratch-hint]');
      if (hint) hint.hidden = true;
      confetti(panel);
      try { localStorage.setItem(key + '_prize', prize.code); } catch (e) {}
    }

    var REVEAL_AT = 0.28;    // was 0.45 — nobody wants to colour in the whole card
    var moveCount = 0;

    canvas.addEventListener('pointerdown', function (e) {
      painting = true;
      last = null;
      if (canvas.setPointerCapture) { try { canvas.setPointerCapture(e.pointerId); } catch (err) {} }
      scratchAt(pointAt(e));
    });
    canvas.addEventListener('pointermove', function (e) {
      if (!painting) return;
      scratchAt(pointAt(e));
      // Check while scratching, not only on release, so it pops the moment
      // it's earned rather than when the finger comes up.
      if (++moveCount % 6 === 0 && clearedFraction() > REVEAL_AT) reveal();
    });
    function endStroke() {
      if (!painting) return;
      painting = false;
      last = null;
      if (clearedFraction() > REVEAL_AT) reveal();
    }
    canvas.addEventListener('pointerup', endStroke);
    canvas.addEventListener('pointerleave', endStroke);
    canvas.addEventListener('pointercancel', endStroke);

    // Keyboard and assistive-tech route: never trap the prize behind a drag
    canvas.setAttribute('tabindex', '0');
    canvas.setAttribute('role', 'button');
    canvas.setAttribute('aria-label', 'Scratch to reveal your offer');
    canvas.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); reveal(); }
    });

    // Never let the prize be hostage to a drag that isn't working
    var revealBtn = root.querySelector('[data-bpd-scratch-reveal]');
    if (revealBtn) revealBtn.addEventListener('click', reveal);

    /* ---- claim ---- */
    /* The point of this card is the MOBILE NUMBER, not a discount.

       It used to send winners to /discount/<CODE>. That was broken twice over:
       none of those codes existed in the store, and there is no checkout any
       more for a Shopify discount to apply to — so a winner handed over their
       number, got redirected to the homepage and received nothing, with no
       error to tell them. Prizes are perks the team honours by hand now, the
       same way the cashback is paid by hand, and the perk is recorded on the
       lead so whoever rings knows what was promised. */
    initLeadForm(form, {
      source: 'scratch_card',
      context: function () { return { prize: prize.value, prizeDetail: prize.sub }; },
      onDone: function (lead) {
        try { localStorage.setItem(key + '_claimed', '1'); } catch (err) {}
        if (claim) claim.hidden = true;
        if (done) done.hidden = false;
        root.dispatchEvent(new CustomEvent('bpd:scratch-claimed', {
          bubbles: true, detail: { prize: prize.value, mobile: lead.mobile },
        }));
      },
    });

    /* ---- open / close ---- */
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      loadFoil();
      root.hidden = false;
      root.offsetHeight;
      root.classList.add('is-open');
      lockScroll();
      paintFoil();
      var c = root.querySelector('[data-bpd-scratch-close]');
      if (c) c.focus();
      try { localStorage.setItem(key, '1'); } catch (e) {}
    }
    function close() {
      root.classList.remove('is-open');
      unlockScroll();
      window.setTimeout(function () {
        if (!root.classList.contains('is-open')) root.hidden = true;
      }, 300);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    var closers = root.querySelectorAll('[data-bpd-scratch-close]');
    for (var i = 0; i < closers.length; i++) closers[i].addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });
    window.addEventListener('resize', function () { if (!revealed) paintFoil(); });

    root.bpdScratch = { open: open, close: close, reveal: reveal, prize: prize };

    var seen = false;
    try { seen = localStorage.getItem(key) === '1'; } catch (e) {}
    if (!seen) {
      window.setTimeout(open, (parseFloat(root.dataset.delay) || 0) * 1000);
    }
  }

  /* ---------- Product page: variant matching + price summary ---------- */
  function initPdp(root) {
    var dataEl = root.querySelector('[data-bpd-pdp-variants]');
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
    if (!variants || !variants.length) return;

    var idInput = root.querySelector('[data-bpd-pdp-variant]');
    var qty = root.querySelector('[data-bpd-pdp-qty]');
    var qtyDec = root.querySelector('[data-bpd-pdp-qtydec]');
    var qtyInc = root.querySelector('[data-bpd-pdp-qtyinc]');
    var submit = root.querySelector('[data-bpd-pdp-submit]');
    var submitLabel = root.querySelector('[data-bpd-pdp-submitlabel]');

    /* This panel lives inside a `{% form 'product' %}`, so the browser will
       happily POST it to /cart/add — that is what a product form is for. There
       is no checkout in this business: the popup collects the credit
       application and the endpoint creates the order. A stray submit here put
       people into Shopify's checkout with none of that collected.

       The button is type="button" now, but Enter in a text field still submits
       a form, so the event is stopped here too and the popup opened instead. */
    var pdpForm = root.querySelector('form');
    if (pdpForm) pdpForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var opener = root.querySelector('[data-bpd-buy-open]');
      if (opener) opener.click();
    });
    var opts = root.querySelectorAll('[data-bpd-pdp-opt]');

    var VAT = 0.2;

    /* Volume tiers: "1:19.95|3:17.95|5:15.95" — minimum quantity : price per
       line. Display only; Shopify must carry matching automatic quantity-break
       discounts or the checkout total won't agree with this panel. */
    var cbPerLine = parseFloat(root.getAttribute('data-cashback-per-line') || '0');
    var cbCap     = parseFloat(root.getAttribute('data-cashback-cap') || '0');
    var cbMonths  = parseInt(root.getAttribute('data-cashback-months'), 10) || 12;

    var tiers = (root.getAttribute('data-tiers') || '')
      .split('|')
      .map(function (t) {
        var bits = t.split(':');
        return { min: parseInt(bits[0], 10), price: parseFloat(bits[1]) };
      })
      .filter(function (t) { return isFinite(t.min) && isFinite(t.price); })
      .sort(function (a, b) { return a.min - b.min; });

    function tierFor(n) {
      var hit = null;
      for (var i = 0; i < tiers.length; i++) if (n >= tiers[i].min) hit = tiers[i];
      return hit;
    }
    function nextTier(n) {
      for (var i = 0; i < tiers.length; i++) if (tiers[i].min > n) return tiers[i];
      return null;
    }

    function chosen() {
      var picked = {};
      for (var i = 0; i < opts.length; i++) {
        if (opts[i].checked) picked[opts[i].getAttribute('data-bpd-pdp-opt')] = opts[i].value;
      }
      return picked;
    }

    function findVariant(picked) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var o = v.options || [v.option1, v.option2, v.option3];
        var ok = true;
        for (var pos in picked) {
          if (!Object.prototype.hasOwnProperty.call(picked, pos)) continue;
          if (String(o[Number(pos) - 1]) !== picked[pos]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function setAll(sel, text) {
      var els = root.querySelectorAll(sel);
      for (var i = 0; i < els.length; i++) els[i].textContent = text;
    }

    function render() {
      var picked = chosen();
      var v = findVariant(picked);

      // Echo each choice next to its label
      for (var pos in picked) {
        if (!Object.prototype.hasOwnProperty.call(picked, pos)) continue;
        var echo = root.querySelector('[data-bpd-pdp-chosen="' + pos + '"]');
        if (echo) echo.textContent = picked[pos];
      }

      var n = Math.max(1, parseInt(qty ? qty.value : '1', 10) || 1);
      var qtyEcho = root.querySelector('[data-bpd-pdp-qtyecho]');
      if (qtyEcho) qtyEcho.textContent = n + (n === 1 ? ' line' : ' lines');
      if (qtyDec) qtyDec.disabled = n <= 1;
      if (qtyInc && qty) qtyInc.disabled = n >= (parseInt(qty.max, 10) || 50);

      if (!v) {
        if (submit) submit.disabled = true;
        if (submitLabel) submitLabel.textContent = 'Not available';
        return;
      }

      if (idInput) idInput.value = v.id;
      var available = v.available !== false;
      if (submit) submit.disabled = !available;
      if (submitLabel && !available) submitLabel.textContent = 'Sold out';
      else if (submitLabel) submitLabel.textContent = submitLabel.getAttribute('data-label') || submitLabel.textContent;

      var listUnit = (Number(v.price) || 0) / 100;   // Shopify prices are in minor units
      var tier = tierFor(n);
      var unit = tier ? tier.price : listUnit;
      var monthly = unit * n;

      var unitTxt = money(unit) + ' × ' + n;
      if (tier && tier.price < listUnit) unitTxt += '  (was ' + money(listUnit) + ' each)';
      setAll('[data-bpd-pdp-unit]', unitTxt);

      // Nudge toward the next break, but only when one actually exists
      var nudge = root.querySelector('[data-bpd-pdp-nudge]');
      if (nudge) {
        var nt = nextTier(n);
        if (nt) {
          var tpl = root.getAttribute('data-tier-next') || '';
          nudge.textContent = tpl
            .replace('{n}', String(nt.min - n))
            .replace('{price}', money(nt.price).replace('£', ''));
          nudge.hidden = false;
        } else {
          nudge.hidden = true;
        }
      }
      setAll('[data-bpd-pdp-vat]', money(monthly * VAT));
      setAll('[data-bpd-pdp-total]', money(monthly));

      // One term, so cashback always applies
      var cashRow = root.querySelector('[data-bpd-pdp-cashrow]');
      var cash = cbPerLine > 0 ? Math.min(cbCap || Infinity, cbPerLine * n) : 0;
      if (cashRow) {
        cashRow.hidden = cash <= 0;
        if (cash > 0) setAll('[data-bpd-pdp-cash]', money(cash) + ' paid to you');
      }

      // Term row: only meaningful on a fixed term, not a rolling line
      var termRow = root.querySelector('[data-bpd-pdp-termrow]');
      var months = 0;
      for (var pos2 in picked) {
        if (!Object.prototype.hasOwnProperty.call(picked, pos2)) continue;
        var m = /(\d+)\s*month/i.exec(picked[pos2]);
        if (m) months = parseInt(m[1], 10);
      }
      if (termRow) {
        termRow.hidden = months === 0;
        if (months) setAll('[data-bpd-pdp-term]', money(monthly * months));
      }

      // One plan, so only the SIM type changes what the mockup should say
      var sim = picked['1'];
      if (sim) setAll('[data-bpd-pdp-devicemeta]', sim + ' · Active since today');
    }

    for (var i = 0; i < opts.length; i++) opts[i].addEventListener('change', render);
    if (qty) qty.addEventListener('input', render);
    if (qtyDec) qtyDec.addEventListener('click', function () { qty.value = String((parseInt(qty.value, 10) || 1) - 1); render(); });
    if (qtyInc) qtyInc.addEventListener('click', function () { qty.value = String((parseInt(qty.value, 10) || 1) + 1); render(); });

    if (submitLabel) submitLabel.setAttribute('data-label', submitLabel.textContent.trim());

    var form = root.querySelector('form');
    if (form) {
      form.addEventListener('submit', function () {
        var n = Math.max(1, parseInt(qty ? qty.value : '1', 10) || 1);
        var v = findVariant(chosen());
        var tier = tierFor(n);
        var unit = tier ? tier.price : ((Number(v && v.price) || 0) / 100);
        track('InitiateCheckout', {
          content_name: 'Business Unlimited',
          content_type: 'product',
          content_ids: v ? [String(v.id)] : [],
          num_items: n,
          value: unit * n,
          currency: 'GBP',
        });
      });
    }

    // The cashback builder links through as ?lines=N — carry it over so what
    // the customer built is what lands in the basket.
    if (qty) {
      var wanted = parseInt((/[?&]lines=(\d+)/.exec(window.location.search) || [])[1], 10);
      if (isFinite(wanted) && wanted > 0) {
        qty.value = String(Math.min(parseInt(qty.max, 10) || 50, wanted));
      }
    }


    // Sticky bar appears once the real buy button scrolls out of view
    var satc = root.querySelector('[data-bpd-satc]');
    if (satc && submit && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        satc.classList.toggle('is-on', !entries[0].isIntersecting);
      }, { rootMargin: '0px 0px -40px 0px' }).observe(submit);
    }

    render();
  }

  /* ---------- Bill calculator ---------- */
  function initCalc(root) {
    var vatRate = parseFloat(root.dataset.vatRate || '20') / 100;
    var range = root.querySelector('[data-bpd-calc-lines]');
    var out = root.querySelector('[data-bpd-calc-out]');
    var dec = root.querySelector('[data-bpd-calc-dec]');
    var inc = root.querySelector('[data-bpd-calc-inc]');
    var plans = root.querySelectorAll('[data-bpd-calc-plan]');
    var current = root.querySelector('[data-bpd-calc-current]');

    var elTotal = root.querySelector('[data-bpd-calc-total]');
    var elSummary = root.querySelector('[data-bpd-calc-linesummary]');
    var elUnit = root.querySelector('[data-bpd-calc-unit]');
    var elInc = root.querySelector('[data-bpd-calc-incvat]');
    var elYear = root.querySelector('[data-bpd-calc-year]');
    var save = root.querySelector('[data-bpd-calc-save]');
    var saveAmt = root.querySelector('[data-bpd-calc-saveamount]');

    if (!range) return;
    var min = parseInt(range.min, 10) || 1;
    var max = parseInt(range.max, 10) || 50;

    function selectedPlan() {
      for (var i = 0; i < plans.length; i++) if (plans[i].checked) return plans[i];
      return plans[0];
    }

    function render() {
      var lines = Math.min(max, Math.max(min, parseInt(range.value, 10) || min));
      paintRange(range);
      var plan = selectedPlan();
      var unit = plan ? parseFloat(plan.value) : 0;
      var name = plan ? plan.getAttribute('data-name') : '';

      var monthly = lines * unit;
      if (out) out.textContent = String(lines);
      if (dec) dec.disabled = lines <= min;
      if (inc) inc.disabled = lines >= max;

      if (elTotal) elTotal.textContent = money(monthly);
      if (elSummary) elSummary.textContent = lines + (lines === 1 ? ' line' : ' lines') + ' × ' + name;
      if (elUnit) elUnit.textContent = money(unit) + ' each';
      if (elInc) elInc.textContent = money(monthly * (1 + vatRate));
      if (elYear) elYear.textContent = money(monthly * 12);

      var now = current ? parseFloat(current.value) : NaN;
      var saving = isFinite(now) && now > unit ? (now - unit) * lines * 12 : 0;
      if (save) {
        save.hidden = saving <= 0;
        if (saving > 0 && saveAmt) saveAmt.textContent = money(saving);
      }
    }

    range.addEventListener('input', render);
    if (dec) dec.addEventListener('click', function () { range.value = String((parseInt(range.value, 10) || min) - 1); render(); });
    if (inc) inc.addEventListener('click', function () { range.value = String((parseInt(range.value, 10) || min) + 1); render(); });
    for (var i = 0; i < plans.length; i++) plans[i].addEventListener('change', render);
    if (current) current.addEventListener('input', render);

    render();
  }

  /* ---------- Mobile drawer ---------- */
  function initDrawer(header) {
    // NB: the drawer sits OUTSIDE <header> — a backdrop-filter on the header
    // would otherwise contain its position:fixed and clip it to the bar.
    var drawer = document.querySelector('[data-bpd-drawer]');
    if (!drawer) return;
    var openBtn = header.querySelector('[data-bpd-drawer-open]');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      // force a frame so the translate transition actually runs
      drawer.offsetHeight;
      drawer.classList.add('is-open');
      lockScroll();
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      unlockScroll();
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      window.setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 300);
      if (lastFocus) lastFocus.focus();
    }

    if (openBtn) openBtn.addEventListener('click', open);
    var closers = drawer.querySelectorAll('[data-bpd-drawer-close]');
    for (var i = 0; i < closers.length; i++) closers[i].addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
    // Any in-page nav closes the drawer
    var links = drawer.querySelectorAll('a[href^="#"], a[href^="/"]');
    for (var j = 0; j < links.length; j++) links[j].addEventListener('click', close);
  }

  /* ---------- Header height, for anchor offsets ---------- */
  function initHeaderHeight(header) {
    function measure() {
      document.documentElement.style.setProperty('--bpd-header-h', header.offsetHeight + 'px');
    }
    measure();
    if (window.ResizeObserver) new ResizeObserver(measure).observe(header);
    else window.addEventListener('resize', measure);
  }

  function boot() {
    // Marks that JS is running, which is what arms the reveal styles. Set here
    // rather than in the layout so a JS error can never hide the page.
    document.documentElement.classList.add('bpd-js');
    initReveal();

    var planRoots = document.querySelectorAll('[data-bpd-plans]');
    for (var i = 0; i < planRoots.length; i++) initPlans(planRoots[i]);

    initCountUps();

    initTicker();

    var welcomeRoots = document.querySelectorAll('[data-bpd-welcome]');
    for (var w0 = 0; w0 < welcomeRoots.length; w0++) initWelcome(welcomeRoots[w0]);

    var sticky = document.querySelector('[data-bpd-stickycta]');
    if (sticky) initStickyCta(sticky);

    var exitRoots = document.querySelectorAll('[data-bpd-exit]');
    for (var x0 = 0; x0 < exitRoots.length; x0++) initExit(exitRoots[x0]);

    var esimRoots = document.querySelectorAll('[data-bpd-esim]');
    for (var e0 = 0; e0 < esimRoots.length; e0++) initEsimCheck(esimRoots[e0]);

    var cbRoots = document.querySelectorAll('[data-bpd-cb]');
    for (var cb0 = 0; cb0 < cbRoots.length; cb0++) initCashback(cbRoots[cb0]);

    var scratchRoots = document.querySelectorAll('[data-bpd-scratch]');
    for (var s0 = 0; s0 < scratchRoots.length; s0++) initScratch(scratchRoots[s0]);

    var pdpRoots = document.querySelectorAll('[data-bpd-pdp]');
    for (var d = 0; d < pdpRoots.length; d++) initPdp(pdpRoots[d]);

    var calcRoots = document.querySelectorAll('[data-bpd-calc]');
    for (var c = 0; c < calcRoots.length; c++) initCalc(calcRoots[c]);

    var buyRoots = document.querySelectorAll('[data-bpd-buy]');
    for (var b1 = 0; b1 < buyRoots.length; b1++) initBuy(buyRoots[b1]);

    /* The buy flow renders only when the product exists. If it doesn't — not
       created yet, unpublished, sold out — every [data-bpd-buy-open] CTA would
       otherwise follow its href to a product page that 404s. Send them to the
       offer instead, so a missing product costs a conversion rather than
       dumping the whole site on an error page. */
    if (!buyRoots.length) {
      document.addEventListener('click', function (e) {
        var t = e.target.closest ? e.target.closest('[data-bpd-buy-open]') : null;
        if (!t) return;
        e.preventDefault();
        var target = document.getElementById('buy') || document.getElementById('build');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    var header = document.querySelector('[data-bpd-header]');
    if (header) { initDrawer(header); initHeaderHeight(header); }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
